"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.match");
require("core-js/modules/es6.typed.uint8-array");
require("core-js/modules/es6.regexp.constructor");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.array.find");
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
var _defineProperty2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _orderLogistics = require("../../api/orderLogistics.js");
var _orderInfo = require("../../api/orderInfo.js");
var _addorder = require("../../api/addorder.js");
var _ordercustomer = require("../../api/ordercustomer.js");
var _dictionary = require("../../api/dictionary.js");
var _jd = require("../../api/jd.js");
var _timers = require("timers");
var _jsBase = require("js-base64");
var _lodash = require("lodash");
var _vueBarcode = _interopRequireDefault(require("vue-barcode"));
var _vueQr = _interopRequireDefault(require("vue-qr"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var req = new XMLHttpRequest();
req.open('GET', document.location, false);
req.send(null);
var userType = req.getResponseHeader('Domain') ? req.getResponseHeader('Domain') : '';
console.log("222222", userType);

// import JsBarcode from 'jsbarcode'
var _default = exports.default = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
  name: 'orderLogistics',
  components: {
    barcode: _vueBarcode.default,
    VueQr: _vueQr.default
  },
  data: function data() {
    var _ref;
    return _ref = {
      importFlag: false,
      userType: "",
      radio: 2,
      tit: "",
      equipment: [{
        value: "0",
        label: "是"
      }, {
        value: "1",
        label: "否"
      }],
      isAccount: [{
        value: "0",
        valueCn: "未到账"
      }, {
        value: "1",
        valueCn: "已到账"
      }],
      isType: [{
        value: "0",
        valueCn: "预售"
      }, {
        value: "1",
        valueCn: "订购"
      }, {
        value: "2",
        valueCn: "换货"
      }],
      chanjetTypeCode: [{
        value: "ND",
        valueCn: "不上送"
      }, {
        value: "Y",
        valueCn: "已上送"
      }, {
        value: "N",
        valueCn: "未上送"
      }],
      chanjetDeliveryTypeCode: [{
        value: "ND",
        valueCn: "不上送"
      }, {
        value: "P",
        valueCn: "初始状态"
      }, {
        value: "Y",
        valueCn: "已上送"
      }, {
        value: "N",
        valueCn: "未上送"
      }],
      isStop: [{
        value: "Y",
        valueCn: "正常"
      }, {
        value: "N",
        valueCn: "截停"
      }],
      newProductNo: [{
        value: "设备",
        valueCn: "设备"
      }, {
        value: "纯配件",
        valueCn: "纯配件"
      }],
      trials: [{
        value: "0",
        valueCn: "试用"
      }, {
        value: "1",
        valueCn: "售卖"
      }],
      isGather: [{
        value: "Y",
        valueCn: "已汇总"
      }, {
        value: "N",
        valueCn: "未汇总"
      }],
      status: [],
      putform: {
        orderNo: "",
        dealer: "",
        provinceName: "",
        city: "",
        number: "",
        equipmentNumberList: [],
        productList: []
      },
      form: {
        orderNo: "",
        equipmentNumber: "",
        pageNo: 1,
        pageSize: 20,
        name: "",
        number: "",
        customerNumber: "",
        isToAccount: "",
        startPayTime: "",
        endPayTime: "",
        productNo: "",
        partNo: "",
        type: "",
        serial: "",
        contactEmail: "",
        contactTelephone: "",
        serialNumber: "",
        promoCode: "",
        startDeliverTime: "",
        endDeliverTime: "",
        countryCode: "",
        tradeNo: "",
        locationPosition: "",
        stopFlag: "",
        gatherType: "",
        chanjetType: "",
        chanjetDeliveryType: "",
        dealerList: [],
        statusList: [],
        payTypeList: []
      },
      locationPositionDate: "",
      locationForm: {
        locationPosition: "",
        orderNoList: []
      },
      jdForm: {
        locationPosition: "",
        orderNoList: []
      },
      jdCancelForm: {
        orderNoList: []
      },
      productNo: [],
      partNo: [],
      loading: false,
      changeloading: false,
      accountloading: false,
      tableData: [],
      currentPage: 1,
      provinceName: "",
      city: "",
      total: 0,
      dialogFormVisible: false,
      dialogFormChangeVisible: false,
      usSkuCountVisible: false,
      dialogVisible: false,
      scanData: '',
      isSubmitting: false,
      formLabelWidth: "100px",
      skus: "",
      dealers: [],
      locationPositions: [],
      locationPositionTop: [],
      locationPositionSplice: [],
      returnFlagList: [{
        value: "是",
        label: "是"
      }, {
        value: "否",
        label: "否"
      }],
      rules: {
        country: [{
          required: true,
          trigger: "blur"
        }],
        equipmentNumber: [{
          required: true,
          trigger: "blur"
        }],
        receiveName: [{
          required: true,
          trigger: "blur"
        }],
        number: [{
          required: false,
          trigger: "blur"
        }],
        orderNo: [{
          required: true,
          trigger: "blur"
        }],
        //cityPostalCode: [{ required: true, trigger: "blur" }],
        address: [{
          required: true,
          trigger: "blur"
        }],
        telephone: [{
          required: true,
          trigger: "blur"
        }],
        unit: [{
          required: true,
          trigger: "blur"
        }],
        price: [{
          required: true,
          trigger: "blur"
        }],
        // logisticsName: [{ required: true, trigger: "blur" }],
        provinceName: [{
          required: false,
          trigger: "blur"
        }],
        city: [{
          required: false,
          trigger: "blur"
        }],
        contactEmail: [{
          required: false,
          trigger: "blur"
        }],
        contactTelephone: [{
          required: false,
          trigger: "blur"
        }]
      }
    }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "locationForm", {
      locationPosition: [{
        required: true,
        trigger: "blur"
      }]
    }), "jdForm", {
      locationPosition: [{
        required: true,
        trigger: "blur"
      }]
    }), "putrules", {
      country: [{
        required: false,
        trigger: "blur"
      }],
      receiveName: [{
        required: false,
        trigger: "blur"
      }],
      number: [{
        required: true,
        trigger: "blur"
      }],
      orderNo: [{
        required: false,
        trigger: "blur"
      }],
      cityPostalCode: [{
        required: false,
        trigger: "blur"
      }],
      address: [{
        required: false,
        trigger: "blur"
      }],
      telephone: [{
        required: false,
        trigger: "blur"
      }],
      unit: [{
        required: false,
        trigger: "blur"
      }],
      price: [{
        required: false,
        trigger: "blur"
      }],
      logisticsName: [{
        required: false,
        trigger: "blur"
      }],
      name: [{
        required: false,
        trigger: "blur"
      }],
      provinceName: [{
        required: false,
        trigger: "blur"
      }],
      city: [{
        required: false,
        trigger: "blur"
      }]
    }), "accountform", {
      id: "",
      isToAccount: ""
    }), "accountrules", {
      isToAccount: [{
        required: true,
        trigger: "change"
      }]
    }), "dialogFormAccount", false), "isDisable", false), "changeid", ""), "name", ""), "names", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "loadings", false), "datas", []), "receiveName", ""), "country", ""), "cityPostalCode", ""), "address", ""), "telephone", ""), "equipmentCounts", 0), "price", ""), "changeform", {
      orderNo: "",
      number: "",
      receiveName: "",
      country: "",
      cityPostalCode: "",
      address: "",
      telephone: "",
      // equipmentCounts: 0,
      unit: "",
      price: "",
      logisticsName: "",
      id: "",
      provinceName: "",
      city: "",
      equipmentNumberList: [],
      contactTelephone: "",
      contactEmail: ""
    }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "addid", ""), "isShow", true), "showEl", false), "isStockingShow", true), "isRemarkShow", true), "isAmericaShow", false), "isProvinceShow", true), "isSupplementaryShow", true), "multipleSelection", []), "dialogFormPrint", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "locationDialog", false), "jdFormDialog", false), "printReallist", []), "prod", "市场部"), "printforms", {}), "printform", []), "printrules", {}), "edit", false), "description", ""), "edits", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "dialogFormClearance", false), "dialogFormSearch", false), "dialogFormBox", false), "dialogFormInvoice", false), "boxs", [{
      receiveName: "",
      address: "",
      invoiceNo: "",
      deliverDate: "",
      country: "",
      orderNo: ""
    }]), "cfr", "CFR"), "boxlist", []), "invoices", [{
      address: "",
      deliverDate: "",
      grossWeight: "",
      invoiceNo: "",
      receiveName: "",
      unit: "",
      orderNo: "",
      subTotalPrice: ""
    }]), "clearances", [{
      country: "",
      grossWeight: "",
      invoiceNo: "",
      netWeight: "",
      receiveName: "",
      orderNo: "",
      logisticsPrice: ""
    }]), "clearanceList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "invoiceList", []), "printFlag", true), "to", "TO:"), "size", "26CM*10CM*32CM"), "bulk", ""), "num", "1"), "img", require("../../assets/img/logos.png")), "totalprice", ""), "unit", ""), "forms", {}), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "dialogCodeVisible", false), "codeform", {
      orderNo: "",
      dealer: "",
      number: "",
      equipmentNumberList: [],
      productList: []
    }), "equipmentCount", []), "coderules", {
      number: [{
        required: true,
        trigger: "change"
      }],
      orderNo: [{
        required: true,
        trigger: "change"
      }],
      equipmentNumberList: [{
        required: true,
        trigger: "change"
      }]
    }), "clearanceFlag", []), "boxFlag", []), "invoiceFlag", []), "boxFlags", []), "invoiceFlags", []), "invoiceShow", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "invoice", [{
      invoiceNo: "",
      receiverCompanyName: "",
      orderNo: "",
      receiverAddress: "",
      receiverPhone: "",
      contact: "",
      vatNumber: "",
      type: "",
      shipping: "",
      invoicePrice: "",
      date: "",
      totalPrice: ""
    }]), "email", "PAYPAL ACCOUNT:account@supernote.com"), "invoiceVolist", []), "shippingFlag", true), "addform", {
      address: "",
      city: "",
      cityPostalCode: "",
      contactEmail: "",
      contactTelephone: "",
      country: "",
      countryCode: "",
      countryId: "",
      dealer: "",
      logistics: "",
      logisticsPrice: "",
      dutyTaxes: "",
      name: "",
      orderNo: "",
      payTime: "",
      payType: [],
      logisticsNumber: "",
      province: "",
      provinceName: "",
      remark: "",
      totalPrice: "",
      unit: "",
      locationPosition: "",
      productList: [],
      equipmentNumberList: [],
      tradeNo: "",
      serialNumber: '',
      applicantUser: '',
      returnFlag: '',
      pickingLocation: ''
    }), "startNumber", ""), "isPackage", "0"), "numberL", ""), "addrules", {
      orderNo: [{
        required: true,
        trigger: "blur"
      }],
      dealer: [{
        required: true,
        trigger: "change"
      }],
      totalPrice: [{
        required: true,
        trigger: "change"
      }],
      logisticsPrice: [{
        required: true,
        trigger: "blur"
      }],
      dutyTaxes: [{
        required: true,
        trigger: "blur"
      }],
      payTime: [{
        required: true,
        trigger: "blur"
      }],
      payType: [{
        required: true,
        trigger: "change"
      }],
      name: [{
        required: true,
        trigger: "change"
      }],
      country: [{
        required: true,
        trigger: "change"
      }],
      unit: [{
        required: true,
        trigger: "change"
      }],
      address: [{
        required: true,
        trigger: "change"
      }],
      contactTelephone: [{
        required: true,
        trigger: "change"
      }],
      logistics: [{
        required: true,
        trigger: "change"
      }],
      locationPosition: [{
        required: true,
        trigger: "change"
      }]
    }), "dialogFormVisibles", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "dialogForm", false), "dialogsForm", false), "flag2", false), "flag3", false), "packageFlag", false), "usRattaFlag", true), "companylogistics", []), "jacket", []), "componentJacket", []), "newList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "exportFlag", false), "functionPanelLeft", 0), "functionPanelTop", 0), "showflag", false), "deriveFlag", false), "deriveFlagProduct", false), "payTypes", []), "airLines", []), "invoiceNo", ""), "type", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "countrys", []), "provinceNames", []), "date", ""), "receiverCompanyName", ""), "receiverAddress", ""), "receiverPhone", ""), "contact", ""), "contact0", ""), "contact1", ""), "contact2", ""), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "contact3", ""), "shipping", ""), "invoicePrice", ""), "profoma", "INVOICE"), "bank", "Bank's infomation： "), "number", "ACCOUNT NUMBER：1001266339147023980"), "bankname", "BANK'S NAME： INDUSTRIAL AND COMMERCIAL BANK OF CHINA SHANGHAI CAO HE JING HI-TECH PARK BRANCH"), "bankaddress", "BANK ADDRESS： 9F,A#,NO.900 YI SHAN ROAD SHANGHAI P.R.CHINA"), "swiftcode", "SWIFT CODE： ICBKCNBJSHI"), "sureLoading", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "equimentFlag", false), "currencys", [{
      value: "RMB",
      label: "RMB"
    }, {
      value: "USD",
      label: "USD"
    }, {
      value: "JPY",
      label: "JPY"
    }]), "equiment", []), "addproductNo", ""), "addcoverNo", ""), "addpenNo", ""), "changeTitle", ""), "orderFlag", false), "printOrder", ""), "printSerial", ""), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "sureFlag", true), "printLoading", false), "getCfr", null), "idList", []), "totalPriceUpper", ""), "updateDto", []), "deleFlag", true), "dollar", ""), "airport", ""), "clearanceShow", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "countryList", []), "invoiceTitle", "COMMERCIAL INVOICE"), "contractFlag", []), "china", "中国"), "other", "闵行其他31119"), "others", "照章征税"), "penNum", "N/M"), "shippingCost", "shipping cost"), "gerFlag", false), "dialogGerForm", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "gertitle", ""), "contacts", "GOOD E READER"), "numbers", "ACCOUNT NUMBER：1001266309147023909"), "banknames", "BANK'S NAME：INDUSTRIAL AND COMMERCIAL BANK OF CHINA SHANGHAI CAO HE JING HI-TECH PARK BRANCH"), "bankaddresss", "BANK ADDRESS：9F,A#,NO.900 YI SHAN ROAD SHANGHAI P.R.CHINA"), "swiftcodes", "SWIFT CODE：ICBKCNBJSHI"), "rate", ""), "rateFlag", false), "gerList", []), "FreightFlag", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "gerInFlag", false), "gerTotal", ""), "totalCostUpper", ""), "orderLineId", ""), "productList", []), "childOrder", ""), "suppleDialog", false), "gatherDialog", false), "suppleform", {
      costType: "",
      tradeNoList: [],
      orderNo: "",
      orderPrice: 0,
      dutyTaxes: 0,
      payTime: "",
      delaer: "",
      unit: "",
      price: "",
      productNo: "",
      productName: "",
      tradeNo: "",
      payType: "",
      remark: ""
    }), "gatherform", {
      deaList: [],
      productNo: "",
      startPayTime: "",
      endPayTime: ""
    }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "supplerules", {
      costType: [{
        required: true,
        trigger: "change"
      }],
      orderNo: [{
        required: true,
        trigger: "change"
      }],
      orderPrice: [{
        required: true,
        trigger: "change"
      }],
      payTime: [{
        required: true,
        trigger: "change"
      }],
      payType: [{
        required: true,
        trigger: "change"
      }]
    }), "gatherrules", {
      deaList: [{
        required: true,
        trigger: "change"
      }],
      startPayTime: [{
        required: true,
        trigger: "change"
      }],
      endPayTime: [{
        required: true,
        trigger: "change"
      }]
    }), "visible", false), "showColumn", [{
      value: '渠道',
      flag: true
    }, {
      value: '订单号',
      flag: true
    }, {
      value: '订单序号',
      flag: true
    }, {
      value: '截停标识',
      flag: true
    }, {
      value: '打印次数',
      flag: true
    }, {
      value: '交易号',
      flag: true
    }, {
      value: '类型',
      flag: true
    }, {
      value: '支付方式',
      flag: true
    }, {
      value: '售后编号',
      flag: true
    }, {
      value: '物流名称',
      flag: true
    }, {
      value: '物流单号',
      flag: true
    }, {
      value: '币种',
      flag: true
    }, {
      value: '运费',
      flag: true
    }, {
      value: '商品总价',
      flag: true
    }, {
      value: '订单总价',
      flag: true
    }, {
      value: '状态',
      flag: true
    }, {
      value: '到账',
      flag: true
    }, {
      value: '设备号',
      flag: true
    }, {
      value: '流水号',
      flag: true
    }, {
      value: '联系人邮箱',
      flag: true
    }, {
      value: '联系人手机号',
      flag: true
    }, {
      value: '优惠码',
      flag: true
    }, {
      value: '发货时间',
      flag: true
    }, {
      value: '支付时间',
      flag: true
    }, {
      value: '创建人',
      flag: true
    }, {
      value: '创建时间',
      flag: true
    }, {
      value: '修改人',
      flag: true
    }, {
      value: '修改时间',
      flag: true
    }, {
      value: '区域仓',
      flag: true
    }, {
      value: '税费',
      flag: true
    }, {
      value: '汇总标识',
      flag: true
    }, {
      value: 'T+销售状态',
      flag: true
    }, {
      value: '航线',
      flag: true
    }, {
      value: 'T+销货状态',
      flag: true
    }, {
      value: '试用标识',
      flag: true
    }, {
      value: '退回',
      flag: true
    }]), "show2Column", [{
      value: '渠道',
      flag: true
    }, {
      value: '订单号',
      flag: true
    }, {
      value: '订单序号',
      flag: true
    }, {
      value: '截停标识',
      flag: true
    }, {
      value: '打印次数',
      flag: true
    }, {
      value: '交易号',
      flag: true
    }, {
      value: '类型',
      flag: true
    }, {
      value: '支付方式',
      flag: true
    }, {
      value: '售后编号',
      flag: true
    }, {
      value: '物流名称',
      flag: true
    }, {
      value: '物流单号',
      flag: true
    }, {
      value: '币种',
      flag: true
    }, {
      value: '运费',
      flag: true
    }, {
      value: '商品总价',
      flag: true
    }, {
      value: '订单总价',
      flag: true
    }, {
      value: '状态',
      flag: true
    }, {
      value: '到账',
      flag: true
    }, {
      value: '设备号',
      flag: true
    }, {
      value: '流水号',
      flag: true
    }, {
      value: '联系人邮箱',
      flag: true
    }, {
      value: '联系人手机号',
      flag: true
    }, {
      value: '优惠码',
      flag: true
    }, {
      value: '发货时间',
      flag: true
    }, {
      value: '支付时间',
      flag: true
    }, {
      value: '创建人',
      flag: true
    }, {
      value: '创建时间',
      flag: true
    }, {
      value: '修改人',
      flag: true
    }, {
      value: '修改时间',
      flag: true
    }, {
      value: '区域仓',
      flag: true
    }, {
      value: '税费',
      flag: true
    }, {
      value: '汇总标识',
      flag: true
    }, {
      value: 'T+销售状态',
      flag: true
    }, {
      value: '航线',
      flag: true
    }, {
      value: 'T+销货状态',
      flag: true
    }, {
      value: '试用标识',
      flag: true
    }, {
      value: '退回',
      flag: true
    }]), "suppleNumber", ""), "strmsg", ""), "locationClickloading", false), "jdLocationClickloading", false), "submitUploadloading", false), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "costTypes", []), "suppleList", []), "suppleFlag", false), "isDele", "1"), "typeflag", true), "penflag", false), "coverflag", false), "cleaFlag", false), "flagList", [{
      flag: true,
      value: '渠道'
    }, {
      flag: true,
      value: '订单号'
    }, {
      flag: true,
      value: '订单序号'
    }, {
      flag: false,
      value: '交易号'
    }, {
      flag: false,
      value: '设备号'
    }, {
      flag: false,
      value: '是否到账'
    }, {
      flag: false,
      value: '类型'
    }, {
      flag: true,
      value: '截停标识'
    }, {
      flag: false,
      value: '收货国家'
    }, {
      flag: true,
      value: '支付方式'
    }, {
      flag: false,
      value: '物流名称'
    }, {
      flag: false,
      value: '产品编号'
    }, {
      flag: false,
      value: '物流单号'
    }, {
      flag: true,
      value: '物流状态'
    }, {
      flag: true,
      value: '流水号'
    }, {
      flag: true,
      value: '联系人邮箱'
    }, {
      flag: true,
      value: '联系人手机号'
    }, {
      flag: true,
      value: '优惠码'
    }, {
      flag: true,
      value: '支付起始时间'
    }, {
      flag: true,
      value: '支付截止时间'
    }, {
      flag: true,
      value: '发货起始时间'
    }, {
      flag: true,
      value: '发货截止时间'
    }, {
      flag: true,
      value: '区域仓'
    }, {
      flag: true,
      value: '汇总标识'
    }, {
      flag: true,
      value: 'T+销售状态'
    }, {
      flag: true,
      value: '航线'
    }, {
      flag: true,
      value: 'T+销货状态'
    }, {
      flag: true,
      value: '退回'
    }]), "searchInfoList", [{
      flag: true,
      value: '渠道'
    }, {
      flag: true,
      value: '订单号'
    }, {
      flag: true,
      value: '订单序号'
    }, {
      flag: false,
      value: '交易号'
    }, {
      flag: false,
      value: '设备号'
    }, {
      flag: false,
      value: '是否到账'
    }, {
      flag: false,
      value: '类型'
    }, {
      flag: true,
      value: '截停标识'
    }, {
      flag: false,
      value: '收货国家'
    }, {
      flag: true,
      value: '支付方式'
    }, {
      flag: false,
      value: '物流名称'
    }, {
      flag: false,
      value: '产品编号'
    }, {
      flag: false,
      value: '物流单号'
    }, {
      flag: true,
      value: '物流状态'
    }, {
      flag: true,
      value: '流水号'
    }, {
      flag: true,
      value: '联系人邮箱'
    }, {
      flag: true,
      value: '联系人手机号'
    }, {
      flag: true,
      value: '优惠码'
    }, {
      flag: true,
      value: '支付起始时间'
    }, {
      flag: true,
      value: '支付截止时间'
    }, {
      flag: true,
      value: '发货起始时间'
    }, {
      flag: true,
      value: '发货截止时间'
    }, {
      flag: true,
      value: '区域仓'
    }, {
      flag: true,
      value: '汇总标识'
    }, {
      flag: true,
      value: 'T+销售状态'
    }, {
      flag: true,
      value: '航线'
    }, {
      flag: true,
      value: 'T+销货状态'
    }, {
      flag: true,
      value: '退回'
    }]), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "searchValue", true), "returnflags", false), "tableDatas", []), "returnform", {
      orderLineCustomerList: []
    }), "tableDatas1", []), "positionList", []), "callBacks", {
      payId: "",
      outTradeNo: ""
    }), "payrule", {
      outTradeNo: [{
        required: true,
        message: "交易号不能为空",
        trigger: "blur"
      }],
      payId: [{
        required: true,
        message: "支付方式不能为空",
        trigger: "change"
      }]
    }), "orderNoList", []), "detailList", []), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_ref, "detailform", {}), "outflagLeft", null), "outflagTop", null), "scrollLeft", 0), "offsetLeft", 0);
  },
  // watch:{
  //   'codeform.orderNo':{
  //       deep:true,
  //       handler(newVal){
  //         if(newVal){
  //            this.$refs.codenumber.focus()

  //         }
  //       }
  //   }
  // },

  computed: {
    senderInfo: function senderInfo() {
      if (this.userType === 'SUPERNOTE') {
        return {
          scc: '91310112312446327B',
          name: '上海超级笔记科技有限公司',
          nameEn: 'Supernote Technology Co.,Ltd.',
          address: 'Room 802,Building 1,No.1189,Qixin Road,Minhang District,Shanghai,P.R.China',
          code: '3111960BSC'
        };
      }
      return {
        scc: '91310112777122285A',
        name: '上海雷塔智能科技有限公司',
        nameEn: 'Ratta Smart Technology Co.,Ltd.',
        address: 'Room 801,Building 1,No.1189,Qixin Road,Minhang District,Shanghai,P.R.China',
        code: '311196945X'
      };
    }
  },
  created: function created() {
    this.entersave();
  },
  mounted: function mounted() {
    var _this = this;
    if (localStorage.getItem('flagList')) {
      this.flagList = JSON.parse(localStorage.getItem('flagList'));
      if (this.flagList.toString() != this.searchInfoList.toString()) {
        this.flagList = this.searchInfoList;
      }
    } else {
      this.flagList = this.searchInfoList;
    }
    if (localStorage.getItem('showColumn')) {
      this.show2Column = JSON.parse(localStorage.getItem('showColumn'));
      if (this.show2Column.toString() != this.showColumn.toString()) {
        this.show2Column = this.showColumn;
      }
    } else {
      this.show2Column = this.showColumn;
    }
    (0, _orderLogistics.getAllCountry)().then(function (res) {
      _this.countryList = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "LOCATION_POSITION",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.locationPositions = res.voList;
      _this.locationPositionSplice = res.voList;
      _this.locationPositionSplice.forEach(function (item, index, arr) {
        if (item.value == "WAIT") {
          arr.splice(index, 1);
        }
      });
    });
    (0, _dictionary.searchDic)({
      name: "LOCATION_POSITION",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.locationPositionTop = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "DEALER",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.dealers = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "STOCK_POSITION",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.positionList = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "LOGISTICS",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.names = res.voList;
    });
    // this.form.startPayTime = new Date()

    (0, _dictionary.searchDic)({
      name: "LOGISTICS_STATUS",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.status = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "AIR_LINE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.airLines = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "PAY_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.payTypes = res.voList;
    });
    (0, _addorder.Diclist)({
      name: "PRODUCT_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this.productNo = res.voList;
      var obj = new Object();
      obj.key = "part-01";
      obj.value = "纯配件";
      _this.productNo.push(obj);
      var obj1 = new Object();
      obj1.key = "part-02";
      obj1.value = "设备";
      _this.productNo.push(obj1);
    });
    (0, _addorder.Diclist)({
      name: "PART",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this.newList = b["PART"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this.partNo = _this.newList;
      }
    });
    var that = this;
    var end = new Date();
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    // this.form.startPayTime = this.formatDate(start);
    // this.form.endPayTime = this.formatDate(end);

    this.getList();
    var btnScroll = this.$refs['btnScroll'];
    btnScroll.addEventListener('scroll', this.handleScroll); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理

    document.addEventListener('click', this.handleFunctionDocumentClick);
  }
}, "created", function created() {
  this.getDomain();
}), "methods", {
  handleScroll: function handleScroll() {
    this.scrollLeft = this.$refs['btnScroll'].scrollLeft || 0;
    // console.log(this.$refs['btnScroll'],'document.getElementById(\'btnScroll\').scrollLeft')
    // console.log(this.$refs['btnScroll'].scrollLeft,'document.getElementById(\'btnScroll\').scrollLeft')
    if (this.$refs['btnScroll'].scrollLeft != this.offsetLeft - this.outflagLeft) {
      // this.invoiceShow = false;
      // this.exportFlag = false;
      // this.gerFlag = false;
      // this.deriveFlag = false;
      // this.clearanceShow = false;
    }
    this.outflagLeft = this.offsetLeft - this.$refs['btnScroll'].scrollLeft;
    if (this.isFunctionMenuOpen()) {
      this.closeAllFunctionMenus();
    }
  },
  //格式化日期
  formatDate: function formatDate(date) {
    // console.log(date,'123')
    var myyear = date.getFullYear();
    var mymonth = date.getMonth() + 1;
    var myweekday = date.getDate();
    if (mymonth < 10) {
      mymonth = "0" + mymonth;
    }
    if (myweekday < 10) {
      myweekday = "0" + myweekday;
    }
    return myyear + "-" + mymonth + "-" + myweekday;
  },
  getDomain: function getDomain() {
    this.userType = userType;
    console.log("333333", userType);
  },
  //查询列表
  getList: function getList(pg) {
    var _this2 = this;
    this.loading = true;
    var obj = this.form;
    if (pg) {
      obj = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, obj), {}, {
        pageNo: pg
      });
    }
    (0, _timers.setTimeout)(function () {
      (0, _orderLogistics.getLists)(obj).then(function (res) {
        if (res.voList == null || res.voList == "") {
          _this2.form.pageNo = 1;
          _this2.currentPage = 1;
          (0, _orderLogistics.getLists)(_this2.form).then(function (re) {
            _this2.tableData = re.voList;
            _this2.total = Number(re.total);
            _this2.loading = false;
          });
        } else {
          _this2.tableData = res.voList;
          _this2.total = Number(res.total);
          _this2.loading = false;
        }
      });
    }, 500);
    this.currentPage = pg ? pg : this.form.pageNo;
  },
  handleCopy: function handleCopy(e) {
    var row = e.row,
      $index = e.$index;
    var url = '';
    url = 'https://supernote.com.cn/#/order/detail?id=';
    return url + this.tableData[$index].orderNo;
  },
  clipboardSuccessHandler: function clipboardSuccessHandler(_ref2) {
    var value = _ref2.value,
      event = _ref2.event;
    this.$message({
      type: 'success',
      message: '复制成功',
      center: true
    });
  },
  //邮件补发
  emailReissue: function emailReissue(v) {
    var _this3 = this;
    this.$confirm("您确定要邮件补发吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      (0, _orderInfo.changeEmail)(v.orderNo).then(function (res) {
        if (res.success) {
          _this3.$message({
            type: 'success',
            message: '操作成功',
            center: true
          });
          _this3.getList();
        } else {
          _this3.$message({
            type: 'error',
            message: res.errorMsg,
            center: true
          });
        }
      });
    });
  },
  handleClick: function handleClick(row) {
    console.log(row);
  },
  saveColumn: function saveColumn() {
    localStorage.setItem("showColumn", JSON.stringify(this.show2Column));
    this.visible = false;
  },
  exportContent: function exportContent(e) {
    this.toggleFunctionMenu('export', e);
  },
  invoiceContent: function invoiceContent(e) {
    this.toggleFunctionMenu('invoice', e);
  },
  clearanContent: function clearanContent(e) {
    this.toggleFunctionMenu('clearance', e);
  },
  toggleFunctionMenu: function toggleFunctionMenu(menuKey, e) {
    var flags = {
      export: 'exportFlag',
      invoice: 'invoiceShow',
      clearance: 'clearanceShow',
      chart: 'deriveFlag',
      chartProduct: 'deriveFlagProduct'
    };
    var flag = flags[menuKey];
    if (!flag) return;
    var willOpen = !this[flag];
    if (willOpen) {
      this.setFunctionPanelPosition(e);
      this.closeAllFunctionMenus();
      this[flag] = true;
    } else {
      this[flag] = false;
    }
    this.gerFlag = false;
  },
  setFunctionPanelPosition: function setFunctionPanelPosition(e) {
    var target = e.target.localName === 'li' ? e.target : e.target.closest('li');
    if (!target) return;
    var rect = target.getBoundingClientRect();
    this.functionPanelLeft = rect.left;
    this.functionPanelTop = rect.bottom + 4;
  },
  isFunctionMenuOpen: function isFunctionMenuOpen() {
    return this.exportFlag || this.invoiceShow || this.clearanceShow || this.deriveFlag || this.deriveFlagProduct;
  },
  closeAllFunctionMenus: function closeAllFunctionMenus() {
    this.exportFlag = false;
    this.invoiceShow = false;
    this.clearanceShow = false;
    this.deriveFlag = false;
    this.deriveFlagProduct = false;
  },
  handleFunctionDocumentClick: function handleFunctionDocumentClick(e) {
    if (!this.isFunctionMenuOpen()) return;
    var menus = [{
      flag: 'exportFlag',
      btn: 'exportBtn',
      panel: 'exportPanel'
    }, {
      flag: 'invoiceShow',
      btn: 'invoiceBtn',
      panel: 'invoicePanel'
    }, {
      flag: 'clearanceShow',
      btn: 'clearanceBtn',
      panel: 'clearancePanel'
    }, {
      flag: 'deriveFlag',
      btn: 'chartBtn',
      panel: 'chartPanel'
    }, {
      flag: 'deriveFlagProduct',
      btn: 'chartProductBtn',
      panel: 'chartProductPanel'
    }];
    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i];
      if (!this[menu.flag]) continue;
      var btn = this.$refs[menu.btn];
      var panel = this.$refs[menu.panel];
      if (btn && btn.contains(e.target)) return;
      if (panel && panel.contains(e.target)) return;
    }
    this.closeAllFunctionMenus();
  },
  runFunctionAction: function runFunctionAction(actionName) {
    this.closeAllFunctionMenus();
    if (typeof this[actionName] === 'function') {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      this[actionName].apply(this, args);
    }
  },
  //分页
  changepage: function changepage(currentPage) {
    this.currentPage = currentPage;
    this.form.pageNo = currentPage;
    localStorage.setItem("form", JSON.stringify(this.form));
    this.getList();
  },
  handleSelectionChange: function handleSelectionChange(val) {
    this.multipleSelection = val;
  },
  //查询
  search: function search() {
    this.getList();
  },
  //T+补推
  tpush: function tpush() {
    var _this4 = this;
    this.loading = true;
    (0, _orderLogistics.tpush)().then(function (res) {
      _this4.loading = false;
      if (res.success) {
        _this4.msgTip("success", "操作成功");
        _this4.getList();
      } else {
        _this4.$message({
          showClose: true,
          type: "error",
          message: res.errorMsg,
          center: true,
          duration: 10000
        });
      }
    });
  },
  //T+补推
  tpushDelivery: function tpushDelivery() {
    var _this5 = this;
    this.loading = true;
    (0, _orderLogistics.tpushDelivery)().then(function (res) {
      _this5.loading = false;
      if (res.success) {
        _this5.msgTip("success", "操作成功");
        _this5.getList();
      } else {
        _this5.$message({
          showClose: true,
          type: "error",
          message: res.errorMsg,
          center: true,
          duration: 10000
        });
      }
    });
  },
  //设置搜索框
  setSearch: function setSearch(e) {
    // this.dialogFormSearch = true;
    if (e == '1') {
      this.dialogFormSearch = true;
    } else if (e == '2') {
      this.visible = true;
    }
  },
  //搜索框确定
  searchSure: function searchSure() {
    localStorage.setItem('flagList', []);
    localStorage.setItem('flagList', JSON.stringify(this.flagList));
    this.empty();
    this.dialogFormSearch = false;
  },
  prodtext: function prodtext() {
    this.prod = "";
  },
  //类型判断
  types: function types(row) {
    if (row.type == "1") {
      return "订购";
    } else if (row.type == "0") {
      return "预售";
    } else {
      return "换货";
    }
  },
  //判断截停
  stops: function stops(row) {
    if (row.stopFlag == "Y") {
      return "正常";
    } else if (row.stopFlag == "N") {
      return "截停";
    }
  },
  //判断试用
  trialTypes: function trialTypes(row) {
    if (row.trialType == "0") {
      return "试用";
    } else if (row.trialType == "1") {
      return "售卖";
    }
  },
  //T+状态
  chanjetTypes: function chanjetTypes(row) {
    if (row.chanjetType == "Y") {
      return "已上送";
    } else if (row.chanjetType == "N") {
      return "未上送";
    } else if (row.chanjetType == "ND") {
      return "不上送";
    }
  },
  //T+状态
  chanjetDeliveryTypes: function chanjetDeliveryTypes(row) {
    if (row.chanjetDeliveryType == "Y") {
      return "已上送";
    } else if (row.chanjetDeliveryType == "N") {
      return "未上送";
    } else if (row.chanjetDeliveryType == "ND") {
      return "不上送";
    } else if (row.chanjetDeliveryType == "P") {
      return "初始状态";
    }
  },
  //判断汇总
  gathers: function gathers(row) {
    if (row.gatherType == "Y") {
      return "已汇总";
    } else if (row.gatherType == "N") {
      return "未汇总";
    }
  },
  //判断是否到账
  isToAccount: function isToAccount(row) {
    if (row.isToAccount == "0") {
      return "未到账";
    } else if (row.isToAccount == "1") {
      return "已到账";
    }
  },
  //京东上送状态格式化
  jdOrderStatusFormatter: function jdOrderStatusFormatter(row) {
    var statusMap = {
      '0': '待申请',
      '1': '申请中',
      '2': '成功',
      '3': '失败'
    };
    return statusMap[row.jdOrderStatus] || row.jdOrderStatus;
  },
  //截停
  logisticsStop: function logisticsStop(v) {
    var _this6 = this;
    this.$confirm("您是否要截停当前选中的记录?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      (0, _orderLogistics.getStop)(v.id).then(function (res) {
        if (res.success) {
          _this6.msgTip("success", "操作成功");
          _this6.getList();
        } else {
          _this6.msgTip("warning", res.errorMsg);
        }
      });
    });
  },
  logisticsStopCan: function logisticsStopCan(v) {
    var _this7 = this;
    this.$confirm("您是否要取消截停当前选中的记录?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      (0, _orderLogistics.getStopCancel)(v.id).then(function (res) {
        if (res.success) {
          _this7.msgTip("success", "操作成功");
          _this7.getList();
        } else {
          _this7.msgTip("warning", res.errorMsg);
        }
      });
    });
  },
  //销售表点击
  derives: function derives(e) {
    this.toggleFunctionMenu('chart', e);
  },
  //销售单品统计点击
  derivesProduct: function derivesProduct(e) {
    this.toggleFunctionMenu('chartProduct', e);
  },
  //清空
  empty: function empty() {
    this.form.orderNo = "";
    this.form.equipmentNumber = "";
    this.form.name = "";
    this.form.number = "";
    this.form.customerNumber = "";
    this.form.isToAccount = "";
    this.form.type = "";
    this.form.startPayTime = "";
    this.form.endPayTime = "";
    this.form.serial = "";
    this.form.startDeliverTime = "";
    this.form.endDeliverTime = "";
    this.form.countryCode = "";
    this.form.payType = "";
    this.form.tradeNo = "";
    this.form.gatherType = "";
    this.form.contactEmail = "";
    this.form.locationPosition = "";
    this.form.contactTelephone = "";
    this.form.serialNumber = "";
    this.form.promoCode = "";
    this.form.dealerList = [];
    this.form.returnFlag = "";
    this.form.statusList = [];
    this.form.payTypeList = [];
    this.form.pageNo = 1;
    this.form.stopFlag = "";
    this.form.airLine = "";
    this.form.productNo = "";
    this.form.chanjetType = "";
    this.form.chanjetDeliveryType = "";
    this.form.partNo = "";
    this.form.pageNo = 1;
    this.currentPage = 1;
    localStorage.removeItem("form");
    this.getList();
  },
  //渠道多选
  changeDealerType: function changeDealerType(val) {
    this.form.dealerList = val;
  },
  //渠道多选-用于一键汇总
  changeDeaType: function changeDeaType(val) {
    this.form.deaList = val;
  },
  //支付类型多选
  changePayType: function changePayType(val) {
    this.form.payTypeList = val;
  },
  //状态多选
  changeStatus: function changeStatus(val) {
    this.form.statusList = val;
  },
  visibleClick: function visibleClick() {
    console.log('123123');
    this.visible = true;
  },
  //支付回调
  callBack: function callBack() {
    this.dialogForm = true;
  },
  //弹框关闭
  usSkuCountClose: function usSkuCountClose() {
    this.usSkuCountVisible = false;
  },
  locationclose: function locationclose() {
    this.locationDialog = false;
    this.locationForm.value = "";
  },
  jdLocationclose: function jdLocationclose() {
    this.jdFormDialog = false;
    this.jdForm.value = "";
  },
  //弹框关闭
  logisticsClose: function logisticsClose() {
    this.dialogForm = false;
    this.$refs.callBacks.resetFields();
  },
  keeps: function keeps() {
    var _this8 = this;
    this.$refs.callBacks.validate(function (valid) {
      if (valid) {
        (0, _orderInfo.orderPay)(_this8.callBacks).then(function (res) {
          _this8.isDisable = true;
          if (res.success) {
            _this8.dialogForm = false;
            _this8.isDisable = false;
            _this8.$message({
              type: 'success',
              message: '回调成功',
              center: true
            });
            _this8.$refs.callBacks.resetFields();
            _this8.getList();
          } else {
            _this8.isDisable = false;
            _this8.$message({
              type: 'error',
              message: res.errorMsg,
              center: true
            });
          }
        });
      }
    });
  },
  //订单详情关闭
  detailClose: function detailClose() {
    this.dialogsForm = false;
  },
  //订单详情
  details: function details() {
    var _this9 = this;
    if (this.multipleSelection.length > 0) {
      this.orderNoList = [];
      this.multipleSelection.map(function (res) {
        _this9.orderNoList.push(res.orderNo);
      });
      (0, _orderInfo.searchList)({
        orderNoList: this.orderNoList
      }).then(function (item) {
        if (item.success) {
          _this9.detailList = item.voList;
          _this9.dialogsForm = true;
        } else {
          _this9.dialogsForm = false;
          _this9.$message({
            type: 'error',
            message: item.errorMsg,
            center: true
          });
        }
      });
    } else {
      this.$message({
        type: 'warning',
        message: '请选择至少一条数据',
        center: true
      });
    }
  },
  //查询美国仓实际库存数量（shopfiy导入前调用）
  submitUpload1: function submitUpload1() {
    var _this10 = this;
    this.submitUploadloading = true;
    (0, _orderLogistics.skuCount)(this.forms).then(function (res) {
      if (res.success) {
        if (res.skus != '' && res.skus != '' && res.skus != undefined) {
          _this10.skus = res.skus;
          _this10.submitUploadloading = false;
          _this10.usSkuCountVisible = true;
        } else {
          document.getElementById('usSkuInput').click();
        }
      }
    });
  },
  submitUpload: function submitUpload() {
    this.usSkuInput();
  },
  usSkuInput: function usSkuInput() {
    this.usSkuCountVisible = false;
    document.getElementById('usSkuInput').click();
  },
  //shopfiy导入
  shopfiyUpload: function shopfiyUpload() {
    var _this11 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadFile.files[0];
    var formFile = new FormData(); //加入文件对象
    formFile.append("file", fileData);
    var extension = fileData.name.split(".")[1] === "xlsx";
    if (!extension) {
      m.close();
      this.msgTip("error", "上传模板只能是xlsx格式!");
      return;
    } else {
      (0, _orderLogistics.getUpload)(formFile).then(function (res) {
        if (res.success) {
          m.close();
          _this11.loadings = false;
          _this11.msgTip("success", res.errorMsg);
          _this11.$refs.uploadFile.value = [];
          _this11.getList();
        } else {
          m.close();
          _this11.loadings = false;
          _this11.msgTip("error", res.errorMsg);
          _this11.$refs.uploadFile.value = [];
        }
      });
    }
  },
  //日亚导入
  submitUploadRiya: function submitUploadRiya() {
    var _this12 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadFileRiya.files[0];
    var formFile = new FormData(); //加入文件对象
    formFile.append("file", fileData);
    var extension = fileData.name.split(".")[1] === "xlsx";
    if (!extension) {
      m.close();
      this.msgTip("error", "上传模板只能是xlsx格式!");
      return;
    } else {
      (0, _orderLogistics.getUploadRiya)(formFile).then(function (res) {
        if (res.success) {
          m.close();
          _this12.msgTip("success", res.errorMsg);
          _this12.$refs.uploadFileRiya.value = [];
          _this12.getList();
        } else {
          m.close();
          _this12.msgTip("error", res.errorMsg);
          _this12.$refs.uploadFileRiya.value = [];
        }
      });
    }
  },
  //天猫&京东导入
  submitUploadTm: function submitUploadTm() {
    var _this13 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadTmFile.files[0];
    var formFile = new FormData();
    formFile.append("file", fileData);
    var extension = fileData.name.split(".")[1] === "xlsx";
    if (!extension) {
      this.msgTip("error", "上传模板只能是xlsx格式!");
      return;
    } else {
      (0, _orderLogistics.getUploadTm)(formFile).then(function (res) {
        if (res.success) {
          m.close();
          _this13.$message({
            type: "success",
            message: res.errorMsg,
            duration: '6000',
            center: true
          });
          _this13.$refs.uploadTmFile.value = [];
          _this13.getList();
        } else {
          m.close();
          _this13.$message({
            type: "warning",
            message: res.errorMsg,
            duration: '6000',
            center: true
          });
          _this13.$refs.uploadTmFile.value = [];
        }
      });
    }
  },
  //VFR导入
  submitUploadVfr: function submitUploadVfr() {
    var _this14 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadVfrFile.files[0];
    var formFile = new FormData();
    formFile.append("file", fileData);
    var extension = fileData.name.split(".")[1] === "xlsx";
    if (!extension) {
      this.msgTip("error", "上传模板只能是xlsx格式!");
      return;
    } else {
      (0, _orderLogistics.getUploadVfr)(formFile).then(function (res) {
        if (res.success) {
          m.close();
          _this14.$message({
            type: "success",
            message: res.errorMsg,
            duration: '3000',
            center: true
          });
          _this14.$refs.uploadVfrFile.value = [];
          _this14.getList();
        } else {
          m.close();
          _this14.$message({
            type: "warning",
            message: res.errorMsg,
            duration: '6000',
            center: true
          });
          _this14.$refs.uploadVfrFile.value = [];
        }
      });
    }
  },
  submitDeliveryUpload: function submitDeliveryUpload() {
    var _this15 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadDeliveryFile.files[0];
    var formFile = new FormData(); //加入文件对象
    formFile.append("file", fileData);
    var extension = fileData.name.split(".")[1] === "xlsx";
    if (!extension) {
      m.close();
      this.msgTip("error", "上传模板只能是xlsx格式!");
      return;
    } else {
      (0, _orderLogistics.getUploadDelivery)(formFile).then(function (res) {
        if (res.success) {
          m.close();
          _this15.msgTip("success", res.errorMsg);
          _this15.$refs.uploadDeliveryFile.value = [];
          _this15.getList();
        } else {
          m.close();
          _this15.$message({
            showClose: true,
            type: "error",
            message: res.errorMsg,
            center: true,
            duration: 20000
          });
          _this15.$refs.uploadDeliveryFile.value = [];
        }
      });
    }
  },
  //DHL运单制单
  submitDhlStockingUpload: function submitDhlStockingUpload() {
    var _this16 = this;
    var m = this.$message({
      type: "success",
      message: '正在处理中......',
      center: true,
      duration: 0
    });
    var fileData = this.$refs.uploadDhlStockingFile.files[0];
    var formFile = new FormData(); //加入文件对象
    formFile.append("file", fileData);
    (0, _orderLogistics.getUploadDhlStocking)(formFile).then(function (res) {
      if (res.success) {
        m.close();
        _this16.msgTip("success", res.errorMsg);
        _this16.$refs.uploadDhlStockingFile.value = [];
        _this16.getList();
      } else {
        m.close();
        _this16.msgTip("error", res.errorMsg);
        _this16.$refs.uploadDhlStockingFile.value = [];
      }
    });
  },
  //京东订单取消出库
  cancelPushJd: function cancelPushJd() {
    var _this17 = this;
    var flag = true;
    if (this.multipleSelection.length > 0) {
      this.jdCancelForm.orderNoList = [];
      var locations = "";
      this.multipleSelection.map(function (res) {
        _this17.jdCancelForm.orderNoList.push(res.orderNo);
        locations = locations + res.locationPosition + ",";
        if (res.locationPosition != "JD" && res.locationPosition != "JDRW") {
          flag = false;
          _this17.$message({
            type: "warning",
            message: "仅京东仓 或 京东售后仓 的订单可以取消",
            duration: '5000',
            center: true
          });
          return;
        }
        if (res.status != "1") {
          flag = false;
          _this17.$message({
            type: "warning",
            message: "仅待发货的订单可以取消",
            duration: '5000',
            center: true
          });
          return;
        }
      });
      this.locationPositionDate = locations;
    } else {
      this.$message({
        type: 'warning',
        message: '请选择至少一条数据',
        center: true
      });
    }
    if (flag) {
      this.loading = true;
      (0, _jd.cancelJdOrder)(this.jdCancelForm).then(function (res) {
        _this17.loading = false;
        if (res.success) {
          _this17.$message({
            type: "success",
            message: "成功",
            center: true
          });
          _this17.getList();
        } else {
          _this17.$message({
            type: "warning",
            message: res.errorMsg,
            duration: '15000',
            center: true
          });
          _this17.isRepeat = false;
          _this17.isDisable = false;
        }
      }).catch(function (error) {
        _this17.loading = false;
        _this17.$message({
          type: "error",
          message: "请求失败，请稍后重试",
          center: true
        });
      });
    }
  },
  //订单上送至京东仓
  pushJd: function pushJd() {
    var _this18 = this;
    var flag = true;
    if (this.multipleSelection.length > 0) {
      this.jdForm.orderNoList = [];
      var locations = "";
      this.multipleSelection.map(function (res) {
        _this18.jdForm.orderNoList.push(res.orderNo);
        locations = locations + res.locationPosition + ",";
        if (res.locationPosition != "SH" && res.locationPosition != "WAIT") {
          flag = false;
          _this18.$message({
            type: "warning",
            message: "仅待转仓 或 上海仓 的订单可以推送至京东仓",
            duration: '5000',
            center: true
          });
          return;
        }
      });
      this.locationPositionDate = locations;
    } else {
      this.$message({
        type: 'warning',
        message: '请选择至少一条数据',
        center: true
      });
    }
    if (flag) {
      this.jdFormDialog = true;
    }
  },
  jdLocationClick: function jdLocationClick() {
    var _this19 = this;
    this.jdLocationClickloading = true;
    (0, _jd.pushJd)(this.jdForm).then(function (res) {
      if (res.success) {
        _this19.$message({
          type: "success",
          message: "成功",
          center: true
        });
        _this19.jdFormDialog = false;
        _this19.jdLocationClickloading = false;
        _this19.getList();
      } else {
        _this19.$message({
          type: "warning",
          message: res.errorMsg,
          duration: '15000',
          center: true
        });
        _this19.jdFormDialog = false;
        _this19.jdLocationClickloading = false;
        _this19.isRepeat = false;
        _this19.isDisable = false;
      }
    });
  },
  //仓位调整
  locationChange: function locationChange() {
    var _this20 = this;
    var flag = true;
    if (this.multipleSelection.length > 0) {
      this.locationForm.orderNoList = [];
      var locations = "";
      // 检查是否有京东仓的订单
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var res = this.multipleSelection[i];
        if (res.locationPosition == "JD" || res.locationPosition == "JDRW") {
          flag = false;
          this.$message({
            type: "warning",
            message: "京东仓的订单不允许调整，请先“取消京东上送”",
            duration: '5000',
            center: true
          });
          return;
        }
      }
      // 如果没有京东仓订单，则继续处理
      this.multipleSelection.map(function (res) {
        _this20.locationForm.orderNoList.push(res.orderNo);
        locations = locations + res.locationPosition + ",";
      });
      this.locationPositionDate = locations;
    } else {
      this.$message({
        type: 'warning',
        message: '请选择至少一条数据',
        center: true
      });
    }
    if (flag) {
      this.locationDialog = true;
    }
  },
  locationClick: function locationClick() {
    var _this21 = this;
    if (this.locationForm.locationPosition === "JDRW" || this.locationForm.locationPosition === "JD") {
      this.$message({
        type: "warning",
        message: "目标仓位是京东仓的，请使用“推送至京东仓”",
        duration: '5000',
        center: true
      });
      return;
    }
    if (this.locationPositionDate.includes("US") && this.locationForm.locationPosition === "USRW") {
      this.$message({
        type: "warning",
        message: "美国仓不允许调整到美国售后仓",
        duration: '5000',
        center: true
      });
      return;
    }
    if (this.locationPositionDate.includes("USRW") && this.locationForm.locationPosition === "US") {
      this.$message({
        type: "warning",
        message: "美国售后仓不允许调整到美国仓",
        duration: '5000',
        center: true
      });
      return;
    }
    this.locationClickloading = true;
    (0, _orderLogistics.locationChange)(this.locationForm).then(function (res) {
      if (res.success) {
        _this21.$message({
          type: "success",
          message: "成功",
          center: true
        });
        _this21.locationDialog = false;
        _this21.locationClickloading = false;
        _this21.getList();
      } else {
        _this21.$message({
          type: "warning",
          message: res.errorMsg,
          duration: '15000',
          center: true
        });
        _this21.locationDialog = false;
        _this21.locationClickloading = false;
        _this21.isRepeat = false;
        _this21.isDisable = false;
      }
    });
  },
  //补录
  suppleAdd: function suppleAdd() {
    var _this22 = this;
    this.suppleDialog = true;
    this.packageFlag = true;
    this.deleFlag = true;
    this.flag2 = false;
    this.flag3 = false;
    this.suppleFlag = false;
    this.isDele = "1";
    (0, _dictionary.searchDic)({
      name: "COST_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this22.costTypes = res.voList;
    });
    (0, _addorder.Diclist)({
      name: "PRODUCT_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this22.type = res.voList;
    });
    (0, _addorder.Diclist)({
      name: "PART",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this22.newList = b["PART"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this22.jacket = _this22.newList;
      }
    });
    (0, _addorder.Diclist)({
      name: "COMPONENT",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this22.newList = b["COMPONENT"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this22.componentJacket = _this22.newList;
      }
    });
  },
  //补录
  gather: function gather() {
    var _this23 = this;
    this.gatherDialog = true;
    (0, _dictionary.searchDic)({
      name: "LOCATION_POSITION",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this23.locationPositions = res.voList;
    });
  },
  //查询订单号
  suppleSearch: function suppleSearch() {
    var _this24 = this;
    var orderNoList = [];
    if (this.suppleform.orderNo.length > 4) {
      orderNoList.push(this.suppleform.orderNo);
      (0, _orderInfo.searchList)({
        orderNoList: orderNoList
      }).then(function (item) {
        if (item.success) {
          _this24.suppleList = item.voList[0].orderInfoDetailList;
          _this24.suppleFlag = true;
        } else {
          _this24.$message({
            type: "error",
            message: item.errorMsg,
            center: true
          });
        }
      });
    } else {
      return false;
    }
  },
  //补录关闭
  suppleClose: function suppleClose() {
    this.suppleDialog = false;
    this.$refs.suppleform.resetFields();
    this.addform.coverNo = "";
    this.isPackage = "0";
    this.addform.penNo = "";
    this.addform.productNo = "";
    this.addform.count = "";
    this.addform.price = "";
    this.suppleform.orderNo = "";
    this.suppleform.costType = "";
    this.suppleform.orderPrice = "";
    this.suppleform.dutyTaxes = "";
    this.suppleform.payTime = "";
    this.suppleform.tradeNo = "";
    this.suppleform.payType = "";
    this.addform.productList = [];
    this.suppleform.tradeNoList = [];
    this.suppleNumber = "";
    this.sureLoading = false;
    this.isDele = "1";
    this.flag2 = false;
    this.flag3 = false;
    this.packageFlag = false;
    this.getList();
  },
  //一键汇总关闭
  gatherClose: function gatherClose() {
    this.gatherDialog = false;
    this.$refs.gatherform.resetFields();
    this.gatherform.productNo = "";
    this.gatherform.deaList = [];
    this.gatherform.startPayTime = "";
    this.gatherform.endPayTime = "";
    this.sureLoading = false;
    this.getList();
  },
  //添加起始编码
  addsNumber: function addsNumber() {
    this.suppleform.tradeNoList.push({
      text: ""
    });
  },
  removesNumber: function removesNumber(index) {
    this.suppleform.tradeNoList.splice(index, 1);
  },
  //补录确定
  supplesure: function supplesure() {
    var _this25 = this;
    this.$refs.suppleform.validate(function (valid) {
      if (valid) {
        if (_this25.isPackage == "") {
          _this25.$message({
            type: "warning",
            message: "请选择套装/配件",
            center: true
          });
        } else {
          _this25.sureLoading = true;
          if (_this25.addform.productList.length == 0) {
            _this25.$message({
              type: "warning",
              message: "请填写完整",
              center: true
            });
            _this25.sureLoading = false;
          } else {
            var data = (0, _objectSpread2.default)({}, _this25.suppleform);
            data.tradeNoList = data.tradeNoList.map(function (v) {
              return v.text;
            });
            data.tradeNoList.push(_this25.suppleNumber);
            (0, _orderLogistics.getSupple)({
              costType: _this25.suppleform.costType,
              orderNo: _this25.suppleform.orderNo,
              orderPrice: _this25.suppleform.orderPrice,
              dutyTaxes: _this25.suppleform.dutyTaxes,
              payTime: _this25.suppleform.payTime,
              productList: _this25.addform.productList,
              tradeNoList: data.tradeNoList,
              tradeNo: _this25.suppleform.tradeNo,
              payType: _this25.suppleform.payType,
              remark: _this25.suppleform.remark
            }).then(function (res) {
              _this25.isDisable = true;
              if (res.success) {
                _this25.suppleDialog = false;
                _this25.isDisable = false;
                _this25.$message({
                  type: "success",
                  message: "补录成功",
                  center: true
                });
                _this25.sureLoading = false;
                _this25.$refs.suppleform.resetFields();
                _this25.addform.coverNo = "";
                _this25.isPackage = "0";
                _this25.addform.penNo = "";
                _this25.addform.productNo = "";
                _this25.suppleform.orderNo = "";
                _this25.suppleform.costType = "";
                _this25.suppleform.orderPrice = "";
                _this25.suppleform.dutyTaxes = "";
                _this25.suppleform.payTime = "";
                _this25.suppleform.tradeNo = "";
                _this25.suppleform.payType = "";
                _this25.addform.productList = [];
                _this25.suppleform.tradeNoList = [];
                _this25.suppleNumber = "";
                _this25.isDele = "1";
                _this25.flag2 = false;
                _this25.flag3 = false;
                _this25.packageFlag = false;
                _this25.getList();
              } else {
                _this25.isDisable = false;
                _this25.$message({
                  type: "error",
                  message: res.errorMsg,
                  center: true
                });
                _this25.sureLoading = false;
              }
            });
          }
        }
      }
    });
  },
  //一键汇总确定
  gathersure: function gathersure() {
    var _this26 = this;
    this.$refs.gatherform.validate(function (valid) {
      if (valid) {
        var data = (0, _objectSpread2.default)({}, _this26.gatherform);
        (0, _orderLogistics.getGatherType)({
          dealerList: _this26.gatherform.deaList,
          productNo: _this26.gatherform.productNo,
          startPayTime: _this26.gatherform.startPayTime,
          endPayTime: _this26.gatherform.endPayTime
        }).then(function (res) {
          _this26.isDisable = true;
          if (res.success) {
            _this26.gatherDialog = false;
            _this26.isDisable = false;
            _this26.$message({
              type: "success",
              message: "一键汇总成功,请去国内平台查看",
              center: true
            });
            _this26.sureLoading = false;
            _this26.$refs.gatherform.resetFields();
            _this26.gatherform.locationPosition = "";
            _this26.gatherform.startPayTime = "";
            _this26.gatherform.endPayTime = "";
            _this26.getList();
          } else {
            _this26.$message({
              showClose: true,
              type: "error",
              message: res.errorMsg,
              center: true,
              duration: 10000
            });
            _this26.sureLoading = false;
            _this26.isDisable = false;
          }
        });
      }
    });
  },
  //录入
  add: function add() {
    var _this27 = this;
    this.dialogFormVisibles = true;
    this.deleFlag = true;
    this.changeTitle = "销售录入";
    this.orderFlag = false;
    this.isDele = "1";
    this.isStockingShow = true;
    this.isRemarkShow = true;
    this.isProvinceShow = true;
    this.isAmericaShow = false;
    this.isSupplementaryShow = true;
    (0, _dictionary.searchDic)({
      name: "LOGISTICS",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this27.companylogistics = res.voList;
    });
    this.packageFlag = true;
    this.flag2 = false;
    this.flag3 = false;
    (0, _addorder.Diclist)({
      name: "PRODUCT_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this27.type = res.voList;
    });
    (0, _dictionary.searchDic)({
      name: "PAY_TYPE",
      pageNo: 1,
      pageSize: 100,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      _this27.payTypes = res.voList;
    });
    (0, _addorder.Diclist)({
      name: "PART",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this27.newList = b["PART"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this27.jacket = _this27.newList;
      }
    });
    (0, _addorder.Diclist)({
      name: "COMPONENT",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this27.newList = b["COMPONENT"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this27.componentJacket = _this27.newList;
      }
    });
  },
  //改变数量
  changeCount: function changeCount(v) {
    if (v) {
      this.$set(this.addform, this.addform.count, v);
    } else {
      this.$set(this.addform, this.addform.count, "");
    }
  },
  //改变价格
  changePrice: function changePrice(v) {
    if (v) {
      this.$set(this.addform, this.addform.price, v);
    } else {
      this.$set(this.addform, this.addform.price, "");
    }
  },
  //刷新
  addreaload: function addreaload() {
    var _this28 = this;
    this.addform.productNo = "";
    this.addform.penNo = "";
    this.addform.coverNo = "";
    this.addform.count = "";
    this.addform.price = "";
    (0, _addorder.Diclist)({
      name: "PART",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this28.newList = b["PART"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this28.jacket = _this28.newList;
      }
    });
    (0, _addorder.Diclist)({
      name: "COMPONENT",
      pageNo: 1,
      pageSize: 1000,
      sortField: "",
      sortRules: "",
      valueMeaning: ""
    }).then(function (res) {
      if (res.success) {
        var b = {};
        res.voList.forEach(function (obj) {
          var array = b[obj["name"]] || [];
          array.push(obj);
          b[obj["name"]] = array;
        });
        _this28.newList = b["COMPONENT"].map(function (v) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
            value: v.value
          });
        });
        _this28.componentJacket = _this28.newList;
      }
    });
  },
  //第二个修改按钮
  changeDealer: function changeDealer(row) {
    var _this29 = this;
    if (row.locationPosition == 'US' || row.dealerId == 'WAIT') {
      this.msgTip("error", "美国仓或待转仓的订单不支持修改");
      return;
    }
    if (row.dealerId == '3' || row.dealerId == '4' || row.dealerId == '18') {
      if (row.orderNo.includes('~') && (row.status == '19' || row.status == '20')) {
        this.msgTip("error", "制单或备货中的补录单不支持修改");
        return;
      }
      this.dialogFormChangeVisible = true;
      // this.isDisable = true;

      (0, _orderLogistics.aloneList)(row.id).then(function (res) {
        _this29.isStockingShow = true;
        _this29.isSupplementaryShow = true;
        if (res.success) {
          _this29.changeform = res.voT;
          if (res.voT.status === "19" || res.voT.status === "20") {
            _this29.isStockingShow = false;
          }
          if (res.voT.orderNo.indexOf("~") != -1) {
            _this29.isSupplementaryShow = false;
          }
          _this29.equiment = res.voT.equipmentNumberList;
          if (res.voT.equipmentNumberList) {
            _this29.isShow = true;
            _this29.changeform.equipmentNumberList = res.voT.equipmentNumberList.map(function (row) {
              return {
                value: row
              };
            });
            _this29.equiment = res.voT.equipmentNumberList;
          } else {
            _this29.isShow = false;
          }
          _this29.isDisable = false;
        } else {
          _this29.msgTip("warning", res.errorMsg);
        }
      });
      this.changeid = row.id;
    } else {
      if (row.orderNo.includes('~') && (row.status == '19' || row.status == '20')) {
        this.msgTip("error", "制单或备货中的补录单不支持修改");
        return;
      }
      this.dialogFormVisibles = true;
      this.changeTitle = "修改";
      this.isDele = "1";
      this.isStockingShow = true;
      this.isRemarkShow = true;
      this.isSupplementaryShow = true;
      (0, _orderLogistics.otherDealer)(row.orderNo).then(function (res) {
        _this29.addform = res.voT;
        if (res.voT.countryCode == 'US') {
          _this29.isAmericaShow = true;
          _this29.isProvinceShow = false;
        } else {
          _this29.isAmericaShow = false;
          _this29.isProvinceShow = true;
        }
        if (res.voT.status === "19" || res.voT.status === "20") {
          _this29.isStockingShow = false;
          _this29.isRemarkShow = false;
          _this29.isAmericaShow = false;
          _this29.isProvinceShow = false;
        }
        if (res.voT.settleType === "Y" || res.voT.dealer === "234") {
          _this29.isStockingShow = false;
        }
        if (!(res.voT.status === "0" || res.voT.status === "1")) {
          _this29.isStockingShow = false;
        }
        if (res.voT.dealer === '17') {
          _this29.usRattaFlag = false;
        }
        if (res.voT.orderNo.indexOf("~") != -1) {
          _this29.isSupplementaryShow = false;
        }
        _this29.addform.equipmentNumberList = res.voT.equipmentNumberList;
        _this29.orderFlag = true;
        // if(res.voT.dealer == '5'){
        //     this.equimentFlag = true
        //     this.addform.equipmentNumberList = res.voT.equipmentNumberList
        // }
        if (res.voT.productList) {
          _this29.showflag = true;
        }
        if (res.voT.dealer == "14" || res.voT.dealer == "19" || res.voT.dealer == "234") {
          _this29.deleFlag = false;
        } else {
          _this29.deleFlag = true;
        }
      });
      (0, _orderLogistics.getCountry)("zh-cn").then(function (res) {
        if (res.success) {
          (0, _orderLogistics.getCountry)("en").then(function (item) {
            if (item.success) {
              var new2 = [].concat((0, _toConsumableArray2.default)(res.voList), (0, _toConsumableArray2.default)(item.voList));
              _this29.countrys = new2;
            }
          });
        }
      });
      (0, _orderLogistics.getProvince)("US").then(function (res) {
        if (res.success) {
          var new2 = (0, _toConsumableArray2.default)(res.voList);
          _this29.provinceNames = new2;
        }
      });
      (0, _dictionary.searchDic)({
        name: "LOGISTICS",
        pageNo: 1,
        pageSize: 100,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        _this29.companylogistics = res.voList;
      });
      this.packageFlag = true;
      this.flag2 = false;
      this.flag3 = false;
      (0, _addorder.Diclist)({
        name: "PRODUCT_TYPE",
        pageNo: 1,
        pageSize: 100,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        _this29.type = res.voList;
      });
      (0, _dictionary.searchDic)({
        name: "PAY_TYPE",
        pageNo: 1,
        pageSize: 100,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        _this29.payTypes = res.voList;
      });
      (0, _addorder.Diclist)({
        name: "PART",
        pageNo: 1,
        pageSize: 1000,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          var b = {};
          res.voList.forEach(function (obj) {
            var array = b[obj["name"]] || [];
            array.push(obj);
            b[obj["name"]] = array;
          });
          _this29.newList = b["PART"].map(function (v) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
              value: v.value
            });
          });
          _this29.jacket = _this29.newList;
        }
      });
      (0, _addorder.Diclist)({
        name: "COMPONENT",
        pageNo: 1,
        pageSize: 1000,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          var b = {};
          res.voList.forEach(function (obj) {
            var array = b[obj["name"]] || [];
            array.push(obj);
            b[obj["name"]] = array;
          });
          _this29.newList = b["COMPONENT"].map(function (v) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
              value: v.value
            });
          });
          _this29.componentJacket = _this29.newList;
        }
      });
    }
  },
  //添加起始编码
  addNumber: function addNumber() {
    this.addform.equipmentNumberList.push({
      text: ""
    });
  },
  removeNumber: function removeNumber(index) {
    this.addform.equipmentNumberList.splice(index, 1);
  },
  isPack: function isPack(v) {
    var _this30 = this;
    if (v == "0") {
      this.packageFlag = true;
      this.flag2 = false;
      this.flag3 = false;
      this.addform.productNo = "";
      this.addform.penNo = "";
      this.addform.coverNo = "";
      (0, _addorder.Diclist)({
        name: "PRODUCT_TYPE",
        pageNo: 1,
        pageSize: 100,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        _this30.type = res.voList;
      });
      (0, _addorder.Diclist)({
        name: "PART",
        pageNo: 1,
        pageSize: 1000,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          var b = {};
          res.voList.forEach(function (obj) {
            var array = b[obj["name"]] || [];
            array.push(obj);
            b[obj["name"]] = array;
          });
          _this30.newList = b["PART"].map(function (v) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
              value: v.value
            });
          });
          _this30.jacket = _this30.newList;
        }
      });
    } else if (v == "1") {
      this.flag2 = true;
      this.flag3 = false;
      this.packageFlag = false;
      this.addform.productNo = '';
      // this.addform.penNo= ''
      // this.addform.coverNo = ''
      this.changeform.penNo = "";
      this.changeform.coverNo = "";
      (0, _addorder.Diclist)({
        name: "PART",
        pageNo: 1,
        pageSize: 1000,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          var b = {};
          res.voList.forEach(function (obj) {
            var array = b[obj["name"]] || [];
            array.push(obj);
            b[obj["name"]] = array;
          });
          _this30.newList = b["PART"].map(function (v) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
              value: v.value
            });
          });
          _this30.jacket = _this30.newList;
        }
      });
    } else if (v == "2") {
      this.flag3 = true;
      this.flag2 = false;
      this.packageFlag = false;
      this.addform.productNo = '';
      this.changeform.penNo = "";
      this.changeform.coverNo = "";
      (0, _addorder.Diclist)({
        name: "COMPONENT",
        pageNo: 1,
        pageSize: 1000,
        sortField: "",
        sortRules: "",
        valueMeaning: ""
      }).then(function (res) {
        if (res.success) {
          var b = {};
          res.voList.forEach(function (obj) {
            var array = b[obj["name"]] || [];
            array.push(obj);
            b[obj["name"]] = array;
          });
          _this30.newList = b["COMPONENT"].map(function (v) {
            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, v), {}, {
              value: v.value
            });
          });
          _this30.componentJacket = _this30.newList;
        }
      });
    }
  },
  //根据渠道判断币种
  showCurrency: function showCurrency() {
    var _this31 = this;
    // if (
    //   this.addform.dealer == "1" ||
    //   this.addform.dealer == "2" ||
    //   this.addform.dealer == "3" ||
    //   this.addform.dealer == "8" ||
    //   this.addform.dealer == "9" ||
    //   this.changeform.dealer == "1" ||
    //   this.changeform.dealer == "2" ||
    //   this.changeform.dealer == "3" ||
    //   this.changeform.dealer == "8" ||
    //   this.changeform.dealer == "9"
    // ) {
    //   this.addform.currency = "RMB";
    //   this.changeform.currency = "RMB"
    // } else if (
    //   this.addform.dealer == "4" ||
    //   this.addform.dealer == "6" ||
    //   this.addform.dealer == "7" ||  this.changeform.dealer == "4" ||
    //   this.changeform.dealer == "6" ||
    //   this.changeform.dealer == "7"
    // ) {
    //   this.addform.currency = "USD";
    //     this.changeform.currency = "USD";
    // } else {
    //   this.addform.currency = "JPY";
    //    this.changeform.currency = "JPY";
    // }

    (0, _orderLogistics.getCountry)("zh-cn").then(function (res) {
      if (res.success) {
        (0, _orderLogistics.getCountry)("en").then(function (item) {
          if (item.success) {
            var new2 = [].concat((0, _toConsumableArray2.default)(res.voList), (0, _toConsumableArray2.default)(item.voList));
            _this31.countrys = new2;
          }
        });
      }
    });
    (0, _orderLogistics.getProvince)("US").then(function (res) {
      if (res.success) {
        var new2 = (0, _toConsumableArray2.default)(res.voList);
        _this31.provinceNames = new2;
      }
    });
    if (this.addform.dealer == "17") {
      this.usRattaFlag = false;
    }

    /*if (this.addform.dealer == "5") {
      this.equimentFlag = true;
    } else {*/
    this.equimentFlag = false;
    this.addform.equipmentNumberList = [];
    this.startNumber = "";
    //}
  },
  addClose: function addClose() {
    this.dialogFormVisibles = false;
    this.usRattaFlag = true;
    this.$refs.addform.resetFields();
    this.addform.unit = "";
    this.addform.dealer = "";
    this.addform.orderNo = "";
    this.addform.totalPrice = "";
    this.addform.logisticsPrice = "";
    this.addform.dutyTaxes = "";
    this.addform.payTime = "";
    this.addform.payType = [];
    this.addform.logistics = "";
    this.addform.logisticsNumber = "";
    this.addform.name = "";
    this.addform.contactTelephone = "";
    this.addform.contactEmail = "";
    this.addform.country = "";
    this.addform.provinceName = "";
    this.addform.locationPosition = "";
    this.addform.city = "";
    this.addform.address = "";
    this.addform.seq = "";
    this.isPackage = "0";
    this.addform.cityPostalCode = '';
    this.addform.tradeNo = '';
    this.addform.serialNumber = '';
    this.addform.applicantUser = '';
    this.addform.returnFlag = '';
    this.addform.remark = "";
    this.addform.seq = "";
    this.addform.sn = "";
    this.equimentFlag = false;
    this.isAmericaShow = false;
    this.isProvinceShow = true;
    this.startNumber = "";
    this.addform.equipmentNumberList = [];
    this.addform.productNo = "";
    this.addform.penNo = "";
    this.addform.coverNo = "";
    /*   this.addform.count = "";
       this.addform.price = "";*/
    this.addform.productList = [];
    this.isDele = "0";
    // this.packageFlag = false;
    this.flag2 = false;
    //this.getList();
  },
  //添加
  addOrder: function addOrder() {
    if (this.isPackage == "0") {
      if (this.addform.count == "" || this.addform.price == "" || this.addform.count == undefined || this.addform.price == undefined) {
        this.$message({
          type: "error",
          message: "请填写完整",
          center: true
        });
      } else {
        var newproductContainsList = [];
        if (this.addproductNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.productName,
            productNameCn: this.productName,
            productNo: this.addproductNo,
            pictureUrl: "",
            type: 1
          });
        }
        if (this.addcoverNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.coverName,
            productNameCn: this.coverName,
            productNo: this.addcoverNo,
            pictureUrl: "",
            type: 2
          });
        }
        if (this.addpenNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.penName,
            productNameCn: this.penName,
            productNo: this.addpenNo,
            pictureUrl: "",
            type: 3
          });
        }
        this.addform.productList.push({
          count: this.isDele == "0" ? "-" + this.addform.count : this.addform.count,
          price: this.addform.price,
          productName: this.productName,
          productNo: this.addproductNo,
          unit: this.addform.currency,
          productContainsList: newproductContainsList
        });
        this.showflag = true;
      }
      this.addproductNo = "";
      this.addpenNo = "";
      this.addcoverNo = "";
      this.addform.price = "";
      this.addform.count = "";
      this.addform.productNo = "";
      this.addform.penNo = "";
      this.addform.coverNo = "";
      this.isDele = "1";
      //  console.log(this.addform.productList,'898989')
    } else {
      if (this.addform.productNo == "" || this.addform.count == "" || this.addform.price == "" || this.addform.count == undefined || this.addform.price == undefined) {
        this.$message({
          type: "error",
          message: "请填写完整",
          center: true
        });
      } else {
        this.addform.productList.push({
          count: this.isDele == "0" ? "-" + this.addform.count : this.addform.count,
          price: this.addform.price,
          productName: this.productName,
          productNo: this.addform.productNo,
          unit: this.addform.currency,
          productContainsList: [{
            count: 1,
            productName: this.productName,
            productNameCn: this.productName,
            productNo: this.addform.productNo,
            pictureUrl: "",
            type: 9
          }]
        });
        this.showflag = true;
        // this.addform.productList.shift()
        //  localStorage.setItem("data", JSON.stringify(this.addform.productList));
      }
      this.addform.productNo = "";
      this.addform.price = "";
      this.addform.count = "";
    }
  },
  //导出备货商品明细报表
  dhlStockingDerive: function dhlStockingDerive() {
    var _this32 = this;
    var statusList = this.form.statusList;
    if (statusList.length > 1) {
      this.msgTip("error", "仅支持物流状态 单选 制单中或备货中");
      return;
    }
    if (statusList[0] != "19" && statusList[0] != "20") {
      this.msgTip("error", "请将物流状态选择为制单中或备货中");
      return;
    }
    this.loading = true;
    var date = this.formatDate(new Date());
    (0, _orderLogistics.dhlStockingExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "备货商品_" + date + ".xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this32.loading = false;
      _this32.getList();
    });
  },
  suppleddOrder: function suppleddOrder() {
    if (this.isPackage == "0") {
      if (this.addform.count == "" || this.addform.price == "" || this.addform.count == undefined || this.addform.price == undefined) {
        this.$message({
          type: "error",
          message: "请填写完整",
          center: true
        });
      } else {
        var newproductContainsList = [];
        if (this.addproductNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.productName,
            productNameCn: this.productName,
            productNo: this.addproductNo,
            pictureUrl: "",
            type: 1
          });
        }
        if (this.addcoverNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.coverName,
            productNameCn: this.coverName,
            productNo: this.addcoverNo,
            pictureUrl: "",
            type: 2
          });
        }
        if (this.addpenNo) {
          newproductContainsList.push({
            count: 1,
            productName: this.penName,
            productNameCn: this.penName,
            productNo: this.addpenNo,
            pictureUrl: "",
            type: 3
          });
        }
        this.addform.productList.push({
          count: this.addform.count,
          price: this.addform.price,
          productName: this.productName,
          productNo: this.addproductNo,
          unit: this.addform.currency,
          productContainsList: newproductContainsList
        });
        this.showflag = true;
      }
      this.addproductNo = "";
      this.addpenNo = "";
      this.addcoverNo = "";
      this.addform.price = "";
      this.addform.count = "";
      this.addform.productNo = "";
      this.addform.penNo = "";
      this.addform.coverNo = "";
      //  console.log(this.addform.productList,'898989')
    } else {
      if (this.addform.productNo == "" || this.addform.count == "" || this.addform.price == "" || this.addform.count == undefined || this.addform.price == undefined) {
        this.$message({
          type: "error",
          message: "请填写完整",
          center: true
        });
      } else {
        this.addform.productList.push({
          count: this.addform.count,
          price: this.addform.price,
          productName: this.productName,
          productNo: this.addform.productNo,
          unit: this.addform.currency,
          productContainsList: [{
            count: 1,
            productName: this.productName,
            productNameCn: this.productName,
            productNo: this.addform.productNo,
            pictureUrl: "",
            type: 9
          }]
        });
        this.showflag = true;
        // this.addform.productList.shift()
        //  localStorage.setItem("data", JSON.stringify(this.addform.productList));
      }
      this.addform.productNo = "";
      this.addform.price = "";
      this.addform.count = "";
    }
  },
  equimentNumber: function equimentNumber(event) {
    this.numberL = event.target.value;
    if (this.numberL.length < 7) {
      this.$message({
        showClose: true,
        type: "error",
        message: "设备号不能小于7位",
        center: true,
        duration: 10000
      });
      return false;
      this.isDisable = true;
    } else {
      this.isDisable = false;
    }
  },
  addsure: function addsure() {
    var _this33 = this;
    console.log("-----------------", this.addform.pickingLocation);
    this.$refs.addform.validate(function (valid) {
      if (valid) {
        if (_this33.isPackage == "") {
          _this33.$message({
            type: "warning",
            message: "请选择套装/配件/零件",
            center: true
          });
        } else {
          _this33.sureLoading = true;
          if (_this33.addform.productList.length == 0) {
            _this33.$message({
              type: "warning",
              message: "请填写完整",
              center: true
            });
            _this33.sureLoading = false;
          } else if (_this33.changeTitle === "销售录入" && _this33.addform.dealer == '16' && _this33.addform.locationPosition != 'SH') {
            _this33.$message({
              type: "error",
              message: "备货渠道区域仓仅支持上海仓",
              center: true
            });
            _this33.sureLoading = false;
          } else if (_this33.changeTitle === "销售录入" && (_this33.addform.dealer == '26' || _this33.addform.dealer == '28') && (!_this33.addform.pickingLocation || _this33.addform.pickingLocation === '')) {
            _this33.$message({
              type: "error",
              message: "请选择备货仓位",
              center: true
            });
            _this33.sureLoading = false;
          } else {
            if (_this33.addform.countryCode != 'US') {
              _this33.addform.province = "";
            }
            if (_this33.changeTitle === "销售录入") {
              var data = (0, _objectSpread2.default)({}, _this33.addform);
              /*if (this.addform.dealer == "5") {
                this.equimentFlag = true;
                data.equipmentNumberList = data.equipmentNumberList.map(
                  (v) => v.text
                );
                data.equipmentNumberList.push(this.startNumber);
              } else {*/
              _this33.startNumber = "";
              data.equipmentNumberList = [];
              /*}*/
              (0, _orderLogistics.addList)({
                address: _this33.addform.address,
                city: _this33.addform.city,
                cityPostalCode: _this33.addform.cityPostalCode,
                contactEmail: _this33.addform.contactEmail,
                contactTelephone: _this33.addform.contactTelephone,
                country: _this33.addform.country,
                countryCode: _this33.addform.countryCode,
                countryId: _this33.addform.countryId,
                dealer: _this33.addform.dealer,
                logistics: _this33.addform.logistics,
                logisticsPrice: _this33.addform.logisticsPrice,
                name: _this33.addform.name,
                locationPosition: _this33.addform.locationPosition,
                orderNo: _this33.addform.orderNo,
                payTime: _this33.addform.payTime,
                dutyTaxes: _this33.addform.dutyTaxes,
                payType: _this33.addform.payType,
                logisticsNumber: _this33.addform.logisticsNumber,
                province: _this33.addform.province,
                provinceName: _this33.addform.provinceName,
                remark: _this33.addform.remark,
                totalPrice: _this33.addform.totalPrice,
                unit: _this33.addform.unit,
                productList: _this33.addform.productList,
                equipmentNumberList: data.equipmentNumberList,
                tradeNo: _this33.addform.tradeNo,
                serialNumber: _this33.addform.serialNumber,
                applicantUser: _this33.addform.applicantUser,
                returnFlag: _this33.addform.returnFlag,
                pickingLocation: _this33.addform.pickingLocation
              }).then(function (res) {
                _this33.isDisable = true;
                if (res.success) {
                  _this33.dialogFormVisibles = false;
                  _this33.isDisable = false;
                  _this33.$message({
                    type: "success",
                    message: "录入成功",
                    center: true
                  });
                  _this33.sureLoading = false;
                  _this33.isAmericaShow = false;
                  _this33.isProvinceShow = true;
                  _this33.$refs.addform.resetFields();
                  _this33.addform.coverNo = "";
                  _this33.isPackage = "0";
                  _this33.addform.logistics = "";
                  _this33.addform.logisticsNo = "";
                  _this33.addform.penNo = "";
                  _this33.addform.productNo = "";
                  _this33.addform.locationPosition = "";
                  _this33.addform.address = "";
                  _this33.addform.dutyTaxes = "";
                  _this33.addform.remake = "";
                  _this33.addform.productList = [];
                  _this33.addform.equipmentNumberList = [];
                  _this33.equimentFlag = false;
                  _this33.usRattaFlag = true;
                  _this33.flag2 = false;
                  _this33.packageFlag = false;
                  _this33.isDele = "0";
                  _this33.getList();
                } else {
                  _this33.isDisable = false;
                  _this33.$message({
                    type: "error",
                    message: res.errorMsg,
                    center: true
                  });
                  _this33.sureLoading = false;
                }
              });
            } else if (_this33.changeTitle === "修改") {
              var _data = (0, _objectSpread2.default)({}, _this33.addform);
              /*  if (this.addform.dealer == "5" && this.equimentFlag == true) {
                  this.equimentFlag = true;
                  data.equipmentNumberList = data.equipmentNumberList.map(
                    (v) => v.text
                  );
                  data.equipmentNumberList.push(this.startNumber);
                } else if (
                  this.addform.dealer == "5" &&
                  this.equimentFlag == false
                ) {
                  data.equipmentNumberList = this.addform.equipmentNumberList;
                }*/
              (0, _orderLogistics.getChange)({
                address: _this33.addform.address,
                city: _this33.addform.city,
                cityPostalCode: _this33.addform.cityPostalCode,
                contactEmail: _this33.addform.contactEmail,
                contactTelephone: _this33.addform.contactTelephone,
                country: _this33.addform.country,
                countryCode: _this33.addform.countryCode,
                countryId: _this33.addform.countryId,
                dealer: _this33.addform.dealer,
                logistics: _this33.addform.logistics,
                logisticsPrice: _this33.addform.logisticsPrice,
                dutyTaxes: _this33.addform.dutyTaxes,
                name: _this33.addform.name,
                orderNo: _this33.addform.orderNo,
                payTime: _this33.addform.payTime,
                payType: _this33.addform.payType,
                logisticsNumber: _this33.addform.logisticsNumber,
                province: _this33.addform.province,
                provinceName: _this33.addform.provinceName,
                remark: _this33.addform.remark,
                totalPrice: _this33.addform.totalPrice,
                unit: _this33.addform.unit,
                productList: _this33.addform.productList,
                equipmentNumberList: _data.equipmentNumberList,
                tradeNo: _this33.addform.tradeNo,
                serialNumber: _this33.addform.serialNumber,
                applicantUser: _this33.addform.applicantUser,
                returnFlag: _this33.addform.returnFlag,
                pickingLocation: _this33.addform.pickingLocation
              }).then(function (res) {
                _this33.isDisable = true;
                if (res.success) {
                  _this33.dialogFormVisibles = false;
                  _this33.isDisable = false;
                  _this33.$message({
                    type: "success",
                    message: "修改成功",
                    center: true
                  });
                  _this33.sureLoading = false;
                  _this33.$refs.addform.resetFields();
                  _this33.addform.coverNo = "";
                  _this33.isPackage = "0";
                  _this33.addform.logistics = "";
                  _this33.addform.logisticsNo = "";
                  _this33.addform.penNo = "";
                  _this33.addform.productNo = "";
                  _this33.addform.address = "";
                  _this33.addform.remake = "";
                  _this33.addform.productList = [];
                  _this33.addform.equipmentNumberList = [];
                  _this33.equimentFlag = false;
                  _this33.usRattaFlag = true;
                  _this33.flag2 = false;
                  _this33.packageFlag = false;
                  _this33.getList();
                } else {
                  _this33.isDisable = false;
                  _this33.$message({
                    type: "error",
                    message: res.errorMsg,
                    center: true
                  });
                  _this33.sureLoading = false;
                }
              });
            }
          }
        }
      }
    });
  },
  //删除
  dele: function dele(v) {
    var _this34 = this;
    this.$confirm("您是否要删除当前选中的记录?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      (0, _orderLogistics.deleList)(v.id).then(function (res) {
        if (res.success) {
          _this34.msgTip("success", "操作成功");
          _this34.getList();
        } else {
          _this34.msgTip("warning", res.errorMsg);
        }
      });
    });
  },
  openDialog: function openDialog() {
    this.dialogVisible = true;
  },
  handleDialogOpen: function handleDialogOpen() {
    var _this35 = this;
    this.$nextTick(function () {
      _this35.$refs.scanInput.focus();
    });
  },
  handleDialogClose: function handleDialogClose() {
    this.scanData = '';
    this.isSubmitting = false;
    this.getList();
  },
  handleSubmit: (0, _lodash.debounce)(function () {
    this.handleRealSubmit(this.scanData);
  }, 500),
  //自动发货
  handleRealSubmit: function () {
    var _handleRealSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(rawData) {
      var _this36 = this;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log("weeeeeeeeeeeeee{}", rawData);
            this.isSubmitting = true;
            if (String(rawData || '').trim()) {
              _context.next = 8;
              break;
            }
            this.$message({
              type: "error",
              message: "未扫描到，请重新扫描!",
              center: true
            });
            this.resetInput();
            return _context.abrupt("return");
          case 8:
            (0, _orderLogistics.deliverAuto)({
              code: rawData
            }).then(function (res) {
              if (res.success) {
                _this36.$message({
                  type: "success",
                  message: "发货成功！<br/>" + res.errorMsg.replace(/\n/g, '<br/>'),
                  dangerouslyUseHTMLString: true,
                  center: true,
                  duration: 2000
                });
                _this36.resetInput();
              } else {
                _this36.$message({
                  showClose: true,
                  type: "error",
                  message: res.errorMsg.replace(/\n/g, '<br/>'),
                  dangerouslyUseHTMLString: true,
                  center: true,
                  duration: 10000
                });
                _this36.resetInput();
              }
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function handleRealSubmit(_x) {
      return _handleRealSubmit.apply(this, arguments);
    }
    return handleRealSubmit;
  }(),
  // 输入重置逻辑
  resetInput: function resetInput() {
    var _this37 = this;
    this.$nextTick(function () {
      _this37.scanData = '';
      _this37.$refs.scanInput.focus();
    });
    this.isSubmitting = false;
  },
  //境内外销售表
  foreign: function foreign() {
    var _this38 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportArea)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "境内外销售表.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this38.loading = false;
    });
  },
  //境内外单品统计
  foreignProduct: function foreignProduct() {
    var _this39 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportAreaProduct)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "境内外单品销售表.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this39.loading = false;
    });
  },
  //各渠道销售表
  ditch: function ditch() {
    var _this40 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportDealer)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "各渠道销售表.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this40.loading = false;
    });
  },
  //各渠道单品统计表
  ditchProduct: function ditchProduct() {
    var _this41 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportDealerProduct)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "各渠道单品销售表.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this41.loading = false;
    });
  },
  //结算表
  accounts: function accounts() {
    var _this42 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportSum)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "结算表.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this42.loading = false;
    });
  },
  //销售总量
  excountry: function excountry() {
    var _this43 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportCountry)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "销售总量.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this43.loading = false;
    });
  },
  //销售明细
  dealerDetail: function dealerDetail() {
    var _this44 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportDetail)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "销售明细.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this44.loading = false;
    });
  },
  //单品销售明细
  dealerDetailProduct: function dealerDetailProduct() {
    var _this45 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportDetailProduct)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "单品销售明细.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this45.loading = false;
    });
  },
  //US-RATTA、日亚备货统计
  jpSpecials: function jpSpecials() {
    var _this46 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportSpecialsDealer)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "日亚备货统计.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this46.loading = false;
    });
  },
  //凌美
  lamyDetail: function lamyDetail() {
    var _this47 = this;
    if (!this.form.startPayTime || this.form.startPayTime.trim() === '' || !this.form.endPayTime || this.form.endPayTime.trim() === '') {
      this.$message({
        type: "error",
        message: "请选择支付开始时间和结束时间",
        center: true
      });
      return;
    }
    ;
    this.loading = true;
    (0, _addorder.exportLamy)({
      startPayTime: this.form.startPayTime,
      endPayTime: this.form.endPayTime,
      timeType: this.form.timeType
    }).then(function (res) {
      var data = new Blob([res], {
        type: "application/.xls"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "lamy.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this47.loading = false;
    });
  },
  //产品编号选择
  changeproductNo: function changeproductNo(v) {
    this.$forceUpdate();
    this.addproductNo = v;
    if (this.isPackage == "0") {
      this.productName = v ? this.type.find(function (ele) {
        return ele.value === v;
      }).valueCn : "";
    } else if (this.isPackage == "1") {
      this.productName = v ? this.jacket.find(function (ele) {
        return ele.value === v;
      }).valueCn : "";
    } else if (this.isPackage == "2") {
      this.productName = v ? this.componentJacket.find(function (ele) {
        return ele.value === v;
      }).valueCn : "";
    }
  },
  //因多层嵌套导致数量不显示问题
  forceUpdateCount: function forceUpdateCount(v) {
    this.$forceUpdate();
  },
  //因多层嵌套导致单价不显示问题
  forceUpdatePrice: function forceUpdatePrice(v) {
    this.$forceUpdate();
  },
  //封套编号选择
  changecoverNo: function changecoverNo(v) {
    this.$forceUpdate();
    if (v) {
      this.$set(this.addform, this.addform.coverNo, v);
      this.addcoverNo = v;
      this.coverName = v ? this.jacket.find(function (ele) {
        return ele.value === v;
      }).valueCn : "";
    } else {
      this.$set(this.addform, this.addform.coverNo, "");
    }
  },
  //笔编号选择
  changepenNo: function changepenNo(v) {
    this.$forceUpdate();
    if (v) {
      this.$set(this.addform, this.addform.penNo, v);
      this.addpenNo = v;
      this.penName = v ? this.jacket.find(function (ele) {
        return ele.value === v;
      }).valueCn : "";
    } else {
      this.$set(this.addform, this.addform.penNo, "");
    }
  },
  //删除
  remove: function remove(index) {
    this.addform.productList.splice(index, 1);
  },
  //到账
  accountClose: function accountClose() {
    this.accountform.isToAccount = "";
    this.dialogFormAccount = false;
  },
  account: function account() {
    var _this48 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.dialogFormAccount = true;
      this.multipleSelection.map(function (res) {
        _this48.accountform.id = res.id;
      });
    }
  },
  accountSure: function accountSure() {
    var _this49 = this;
    this.$refs.accountform.validate(function (valid) {
      if (valid) {
        (0, _orderLogistics.toAccount)(_this49.accountform).then(function (res) {
          if (res.success) {
            _this49.msgTip("success", "操作成功");
            _this49.dialogFormAccount = false;
            _this49.getList();
            _this49.accountform.isToAccount = "";
          } else {
            _this49.isDisable = true;
            _this49.msgTip("warning", res.errorMsg);
          }
        });
      }
    });
  },
  //发货
  shipments: function shipments(v) {
    var _this50 = this;
    if (v.status !== "19") {
      this.msgTip("warning", "仅能发货未发货记录");
    } else {
      this.dialogFormVisible = true;
      this.putform.orderNo = v.orderNo;
      this.name = v.name;
      this.addid = v.id;
      this.putform.type = v.type;
      (0, _orderLogistics.searchBag)(v.id).then(function (res) {
        if (res.success) {
          if (res.voList[0].equipmentCounts == 0) {
            _this50.isShow = false;
          } else {
            _this50.isShow = true;
          }
          (0, _ordercustomer.getOrderNo)(res.voList[0].orderNo).then(function (res) {
            if (res.success) {
              _this50.tableDatas1 = res.voT.productList;
              // this.returnflags = true;
            } else {
              _this50.$message({
                type: "error",
                message: res.errorMsg,
                center: true
              });
            }
          });
          _this50.receiveName = res.voList[0].receiveName;
          _this50.country = res.voList[0].country;
          _this50.cityPostalCode = res.voList[0].cityPostalCode;
          _this50.address = res.voList[0].address;
          _this50.telephone = res.voList[0].telephone;
          _this50.equipmentCounts = res.voList[0].equipmentCounts;
          _this50.unit = res.voList[0].unit;
          _this50.price = res.voList[0].price;
          _this50.putform.provinceName = res.voList[0].provinceName;
          _this50.putform.dealer = res.voList[0].dealer;
          _this50.putform.city = res.voList[0].city;
          _this50.putform.equipmentNumberList = Array.from({
            length: _this50.equipmentCounts
          }).map(function (v) {
            return {
              value: ""
            };
          });
        } else {
          _this50.$message({
            type: "error",
            message: res.errorMsg,
            center: true
          });
        }
      });
    }
  },
  //时间格式化处理
  dateFtt: function dateFtt(fmt, date) {
    var o = {
      "M+": date.getMonth() + 1,
      //月份
      "d+": date.getDate(),
      //日
      "h+": date.getHours(),
      //小时
      "m+": date.getMinutes(),
      //分
      "s+": date.getSeconds(),
      //秒
      "q+": Math.floor((date.getMonth() + 3) / 3),
      //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    return fmt;
  },
  //发货取消按钮
  putClose: function putClose() {
    this.equipmentCounts = 0;
    this.accountloading = false;
    this.$refs.putform.resetFields();
    this.dialogFormVisible = false;
  },
  //发货确定按钮
  sure: function sure(formName) {
    var _this51 = this;
    this.$refs[formName].validate(function (valid) {
      if (valid) {
        var keyMaps = {
          productContainsVOList: 'productContainsList'
        };
        for (var i = 0; i < _this51.tableDatas1.length; i++) {
          var obj = _this51.tableDatas1[i];
          for (var key in obj) {
            var newKey = keyMaps[key];
            if (newKey) {
              obj[newKey] = obj[key];
            }
          }
        }
        _this51.putform.productList = _this51.tableDatas1;
        var data = (0, _objectSpread2.default)({}, _this51.putform);
        data.equipmentNumberList = data.equipmentNumberList.map(function (v) {
          return v.value;
        });
        data.id = _this51.addid;
        var arr = data.equipmentNumberList.filter(function (it) {
          return it != "";
        });
        // if (datas.equipmentNumberList == [] && this.equipmentCounts !== 0) {
        if (arr.length !== _this51.equipmentCounts && _this51.equipmentCounts > 0) {
          _this51.$message({
            showClose: true,
            type: "error",
            message: "请输入设备号",
            center: true,
            duration: 10000
          });
        } else {
          _this51.isDisable = true;
          _this51.accountloading = true;
          console.log('1232111', data.dealer);
          if (data.dealer == '234') {
            (0, _orderLogistics.returnlogistics)(data).then(function (res) {
              if (res.success) {
                _this51.$message({
                  type: "success",
                  message: data.orderNo + " -- 发货成功",
                  center: true,
                  duration: 5000
                });
                _this51.dialogFormVisible = false;
                _this51.getList();
                _this51.$refs[formName].resetFields();
                _this51.tableDatas1 = [];
                data.equipmentNumberList = [];
              } else {
                _this51.$message({
                  showClose: true,
                  type: "error",
                  message: res.errorMsg,
                  center: true,
                  duration: 10000
                });
              }
              _this51.accountloading = false;
              _this51.isDisable = false;
            });
          } else {
            (0, _orderLogistics.deliverList)(data).then(function (res) {
              if (res.success) {
                _this51.$message({
                  type: "success",
                  message: data.orderNo + " -- 发货成功",
                  center: true,
                  duration: 5000
                });
                _this51.dialogFormVisible = false;
                _this51.getList();
                _this51.$refs[formName].resetFields();
                _this51.tableDatas1 = [];
                data.equipmentNumberList = [];
              } else {
                _this51.$message({
                  showClose: true,
                  type: "error",
                  message: res.errorMsg,
                  center: true,
                  duration: 10000
                });
              }
              _this51.accountloading = false;
              _this51.isDisable = false;
            });
          }
        }
      }
    });
  },
  //修改关闭按钮
  changeClose: function changeClose() {
    this.dialogFormChangeVisible = false;
    this.$refs.changeform.resetFields();
  },
  //修改
  change: function change(v) {
    var _this52 = this;
    if (v.orderNo.includes('~') && (v.status == '19' || v.status == '20')) {
      this.msgTip("error", "制单或备货中的补录单不支持修改");
      return;
    }
    this.dialogFormChangeVisible = true;
    // this.isDisable = true;

    (0, _orderLogistics.aloneList)(v.id).then(function (res) {
      _this52.isStockingShow = true;
      _this52.isSupplementaryShow = true;
      if (res.success) {
        _this52.changeform = res.voT;
        if (res.voT.status === "19" || res.voT.status === "20") {
          _this52.isStockingShow = false;
        }
        if (res.voT.orderNo.indexOf("~") != -1) {
          _this52.isSupplementaryShow = false;
        }
        _this52.equiment = res.voT.equipmentNumberList;
        if (res.voT.equipmentNumberList) {
          _this52.isShow = true;
          _this52.changeform.equipmentNumberList = res.voT.equipmentNumberList.map(function (v) {
            return {
              value: v
            };
          });
          _this52.equiment = res.voT.equipmentNumberList;
        } else {
          _this52.isShow = false;
        }
        _this52.isDisable = false;
      } else {
        _this52.msgTip("warning", res.errorMsg);
      }
    });
    this.changeid = v.id;
  },
  //修改确定按钮
  keep: function keep(formName) {
    var _this53 = this;
    this.$refs[formName].validate(function (valid) {
      if (valid) {
        _this53.changeform.id = _this53.changeid;
        _this53.changeloading = true;
        if (_this53.changeform.equipmentNumberList == null || _this53.equiment.length == 0) {
          (0, _orderLogistics.changeList)(_this53.changeform).then(function (res) {
            if (res.success) {
              _this53.msgTip("success", "修改成功");
              _this53.changeloading = false;
              _this53.dialogFormChangeVisible = false;
              _this53.getList();
              _this53.$refs[formName].resetFields();
              _this53.isDisable = false;
            } else {
              _this53.msgTip("warning", res.errorMsg);
              _this53.isDisable = false;
              _this53.changeloading = false;
            }
          });
        } else if (_this53.changeform.equipmentNumberList.some(function (val) {
          return val.value === "";
        })) {
          _this53.msgTip("error", "设备号数量不匹配");
          _this53.changeloading = false;
          return false;
        } else {
          var newArr = [];
          _this53.changeform.equipmentNumberList.map(function (item) {
            newArr.push(item.value);
          });
          _this53.changeform.equipmentNumberList = newArr;
          (0, _orderLogistics.changeList)(_this53.changeform).then(function (res) {
            if (res.success) {
              _this53.msgTip("success", "修改成功");
              _this53.changeloading = false;
              _this53.dialogFormChangeVisible = false;
              _this53.getList();
              _this53.$refs[formName].resetFields();
              _this53.isDisable = false;
            } else {
              _this53.msgTip("warning", res.errorMsg);
              _this53.isDisable = false;
              _this53.changeloading = false;
            }
          });
        }
      }
    });
  },
  //查询子菜单
  rowExpand: function rowExpand(row) {
    var _this54 = this;
    (0, _orderLogistics.searchBag)(row.id).then(function (res) {
      _this54.loadings = true;
      if (res.success) {
        _this54.tableData.map(function (item) {
          if (row.id == item.id) {
            item.children = res.voList;
            _this54.loadings = false;
          }
        });
      } else {
        _this54.$message({
          type: "error",
          message: res.errorMsg,
          center: true
        });
      }
    });
  },
  //弹框封装
  msgTip: function msgTip(msgType, msgInfo) {
    this.$message({
      type: msgType,
      message: msgInfo,
      center: true
    });
  },
  //GER
  ger: function ger(e) {
    this.getPosition(e);
    this.gerFlag = !this.gerFlag;
    this.exportFlag = false;
    this.invoiceShow = false;
    this.deriveFlag = false;
    this.deriveFlagProduct = false;
    this.clearanceShow = false;
  },
  gerClose: function gerClose() {
    this.dialogGerForm = false;
  },
  //GER运费
  Freight: function Freight(v) {
    var _this55 = this;
    if (v == 1) {
      this.gertitle = "Shipping Invoice";
      this.rateFlag = true;
      this.delFlag = true;
      (0, _orderLogistics.getFreight)(this.form).then(function (res) {
        if (res.success) {
          _this55.dialogGerForm = true;
          _this55.invoiceNo = "INVOICE NO：" + res.voT.invoiceNo;
          _this55.date = "INVOICE DATE：" + res.voT.invoiceDate;
          _this55.rateFlag = true;
          _this55.FreightFlag = true;
          _this55.gerInFlag = false;
          _this55.rate = res.voT.rate;
          _this55.gerList = res.voT.freightList;
          _this55.gerTotal = res.voT.totalCost;
          _this55.totalCostUpper = res.voT.totalCostUpper;
        } else if (res.errorCode == "E1681") {
          _this55.$message({
            showClose: true,
            type: "error",
            message: res.errorMsg,
            center: true,
            duration: 600000
          });
        } else {
          _this55.msgTip("error", res.errorMsg);
        }
      });
    } else if (v == 2) {
      this.gertitle = "INVOICE";
      this.rateFlag = false;
      this.delFlag = true;
      (0, _orderLogistics.getGerInvoice)(this.form).then(function (res) {
        if (res.success) {
          _this55.dialogGerForm = true;
          _this55.invoiceNo = "INVOICE NO：" + res.voT.invoiceNo;
          _this55.date = "INVOICE DATE：" + res.voT.invoiceDate;
          _this55.gerList = res.voT.invoiceList;
          _this55.FreightFlag = false;
          _this55.gerInFlag = true;
          _this55.gerTotal = res.voT.totalCost;
          _this55.totalCostUpper = res.voT.totalCostUpper;
        } else if (res.errorCode == "E1681") {
          _this55.$message({
            showClose: true,
            type: "error",
            message: res.errorMsg,
            center: true,
            duration: 600000
          });
        } else {
          _this55.msgTip("error", res.errorMsg);
        }
      });
    }
  },
  //ger删除某一行
  gerDel: function gerDel(index) {
    this.gerList.splice(index, 1);
  },
  gerHtml: function gerHtml() {
    var _this56 = this;
    this.delFlag = false;
    this.dialogGerForm = false;
    //取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("trident") > -1) {
      alert("请使用google或者360浏览器打印");
      this.dialogGerForm = false;
      return false;
    } else if (userAgent.indexOf("msie") > -1) {
      var onlyChoseAlert = simpleAlert({
        content: "请使用Google或者360浏览器打印",
        buttons: {
          确定: function 确定() {
            onlyChoseAlert.close();
          }
        }
      });
      alert("请使用google或者360浏览器打印");
      this.dialogGerForm = false;
      return false;
    } else {
      //其它浏览器使用lodop
      this.printFlag = false;
      (0, _timers.setTimeout)(function () {
        var oldstr = document.body.innerHTML;
        var headstr = "<html><head><title></title></head><body>";
        var footstr = "</body></html>";
        //执行隐藏打印区域不需要打印的内容
        //document.getElementById("otherpho").style.display="none";
        var checkInputs = document.querySelectorAll("input:checked"); // 获取选中的input
        var substr = "";
        var check = "";
        for (var i = 0; i < checkInputs.length; i++) {
          var v = checkInputs[i].value;
          if (v) {
            substr = new RegExp("value=\"".concat(v, "\""));
            check = v;
          }
        }
        var printData = document.getElementById("gerForm").innerHTML; //获得 div 里的所有 html 数据
        // var str = printData.replace('checked="checked"', '')
        // var str1 = str.replace(substr, `value="${check}" checked="checked"`)
        var wind = window.open("", "newwin", "toolbar=no,scrollbars=yes,menubar=no");
        wind.document.body.innerHTML = printData;
        wind.print();
        //打印结束后，放开隐藏内容
        _this56.dialogGerForm = false;
        localStorage.setItem("form", JSON.stringify(_this56.form));
        //document.getElementById("otherpho").style.display="block";
        //window.close();
        parent.location.reload();
        // window.document.body.innerHTML = oldstr;
      }, 1000);
    }
  },
  getPosition: function getPosition(e) {
    // console.log(e)
    if (e.target.localName == 'li') {
      this.outflagLeft = e.target.offsetLeft - this.scrollLeft;
      this.offsetLeft = e.target.offsetLeft;
      this.outflagTop = e.target.offsetTop + 50;
    } else {
      this.outflagLeft = e.target.offsetParent.offsetLeft - this.scrollLeft;
      this.offsetLeft = e.target.offsetParent.offsetLeft;
      this.outflagTop = e.target.offsetParent.offsetTop + 50;
    }
  },
  //普通发票
  planInvoice: function planInvoice() {
    var _this57 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.dialogFormInvoice = true;
      this.tit = "普通发票";
      this.multipleSelection.map(function (res) {
        (0, _orderLogistics.getInvoices)({
          from: 1,
          orderNo: res.orderNo,
          type: 1
        }).then(function (item) {
          _this57.invoice = item.voT;
          _this57.invoiceNo = item.voT.invoiceNo;
          _this57.receiverCompanyName = item.voT.receiverCompanyName;
          _this57.receiverAddress = item.voT.receiverAddress;
          _this57.receiverPhone = item.voT.receiverPhone;
          _this57.contact = item.voT.contact;
          _this57.shipping = item.voT.shipping;
          _this57.totalPriceUpper = "SAY US DOLLARS  " + item.voT.totalPriceUpper;
          if (_this57.shipping == 0) {
            _this57.shippingFlag = false;
          } else {
            _this57.shippingFlag = true;
          }
          _this57.invoiceVolist = item.voT.orderLineInfoVOList;
          var reducer = function reducer(accumulator, currentValue) {
            return accumulator + Number(currentValue.amount);
          };
          _this57.invoicePrice = _this57.invoiceVolist.reduce(reducer, 0) + Number(item.voT.shipping);
          var invoicedate = new Date();
          _this57.date = _this57.formatDate(invoicedate);
          if (item.success) {} else {
            _this57.dialogFormInvoice = false;
            _this57.msgTip("error", item.errorMsg);
          }
        });
      });
    }
  },
  SFInvoice: function SFInvoice() {
    var _this58 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.dialogFormInvoice = true;
      this.tit = "SF合同";
      this.profoma = "CONTRACT";
      this.multipleSelection.map(function (res) {
        (0, _orderLogistics.getInvoices)({
          from: 1,
          orderNo: res.orderNo,
          type: 1
        }).then(function (item) {
          _this58.invoice = item.voT;
          _this58.invoiceNo = item.voT.invoiceNo;
          _this58.receiverCompanyName = item.voT.receiverCompanyName;
          _this58.receiverAddress = item.voT.receiverAddress;
          _this58.receiverPhone = item.voT.receiverPhone;
          _this58.contact = item.voT.contact;
          _this58.shipping = "0";
          _this58.totalPriceUpper = "";
          if (_this58.shipping == 0) {
            _this58.shippingFlag = false;
          } else {
            _this58.shippingFlag = true;
          }
          _this58.invoiceVolist = item.voT.orderLineInfoVOList;
          var reducer = function reducer(accumulator, currentValue) {
            return accumulator + Number(currentValue.amount);
          };
          _this58.invoicePrice = _this58.invoiceVolist.reduce(reducer, 0) + Number(_this58.shipping);
          var invoicedate = new Date();
          _this58.date = _this58.formatDate(invoicedate);
          if (item.success) {} else {
            _this58.dialogFormInvoice = false;
            _this58.msgTip("error", item.errorMsg);
          }
        });
      });
    }
  },
  changeShipping: function changeShipping() {
    var _this59 = this;
    if (this.shipping == 0) {
      this.shippingFlag = false;
      this.multipleSelection.map(function (res) {
        (0, _orderLogistics.getInvoices)({
          from: 1,
          orderNo: res.orderNo,
          type: 1
        }).then(function (item) {
          var reducer = function reducer(accumulator, currentValue) {
            return accumulator + Number(currentValue.amount);
          };
          _this59.invoicePrice = _this59.invoiceVolist.reduce(reducer, 0) + Number(_this59.shipping);
        });
      });
    }
  },
  //国家选择
  countrySelect: function countrySelect(data) {
    var value = data.value,
      label = data.label,
      code = data.code;
    this.addform.countryId = value;
    this.addform.country = label;
    this.addform.countryCode = code;
    if (code == 'US') {
      this.isAmericaShow = true;
      this.addform.provinceName = "";
      this.isProvinceShow = false;
    } else {
      this.isAmericaShow = false;
      this.addform.provinceName = "";
      this.addform.province = "";
      this.isProvinceShow = true;
    }
  },
  //国家选择
  provinceSelect: function provinceSelect(data) {
    var value = data.value,
      code = data.code;
    this.addform.provinceName = value;
    this.addform.province = code;
  },
  //发票关闭
  invoiceClose: function invoiceClose() {
    this.dialogFormInvoice = false;
  },
  //发票确定
  invoiceSure: function invoiceSure() {
    var _this60 = this;
    this.dialogFormInvoice = false;
    //取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("trident") > -1) {
      alert("请使用google或者360浏览器打印");
      this.dialogFormInvoice = false;
      return false;
    } else if (userAgent.indexOf("msie") > -1) {
      var onlyChoseAlert = simpleAlert({
        content: "请使用Google或者360浏览器打印",
        buttons: {
          确定: function 确定() {
            onlyChoseAlert.close();
          }
        }
      });
      alert("请使用google或者360浏览器打印");
      this.dialogFormInvoice = false;
      return false;
    } else {
      //其它浏览器使用lodop
      this.printFlag = false;
      (0, _timers.setTimeout)(function () {
        var oldstr = document.body.innerHTML;
        var headstr = "<html><head><title></title></head><body>";
        var footstr = "</body></html>";
        //执行隐藏打印区域不需要打印的内容
        //document.getElementById("otherpho").style.display="none";
        var checkInputs = document.querySelectorAll("input:checked"); // 获取选中的input
        var substr = "";
        var check = "";
        for (var i = 0; i < checkInputs.length; i++) {
          var v = checkInputs[i].value;
          if (v) {
            substr = new RegExp("value=\"".concat(v, "\""));
            check = v;
          }
        }
        var printData = document.getElementById("invoiceForm").innerHTML; //获得 div 里的所有 html 数据
        // var str = printData.replace('checked="checked"', '')
        // var str1 = str.replace(substr, `value="${check}" checked="checked"`)
        var wind = window.open("", "newwin", "toolbar=no,scrollbars=yes,menubar=no");
        wind.document.body.innerHTML = printData;
        wind.print();
        //打印结束后，放开隐藏内容
        _this60.dialogFormInvoice = false;
        localStorage.setItem("form", JSON.stringify(_this60.form));
        //document.getElementById("otherpho").style.display="block";
        //window.close();
        parent.location.reload();
        // window.document.body.innerHTML = oldstr;
      }, 1000);
    }
  },
  //公司发票
  firmInvoice: function firmInvoice() {
    var _this61 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.dialogFormInvoice = true;
      this.tit = "抬头发票";
      this.multipleSelection.map(function (res) {
        (0, _orderLogistics.getInvoices)({
          from: 1,
          orderNo: res.orderNo,
          type: 1
        }).then(function (item) {
          _this61.invoice = item.voT;
          _this61.invoiceVolist = item.voT.orderLineInfoVOList;
          _this61.invoiceNo = item.voT.invoiceNo;
          _this61.receiverCompanyName = item.voT.receiverCompanyName;
          _this61.receiverAddress = item.voT.receiverAddress;
          _this61.receiverPhone = item.voT.receiverPhone;
          _this61.shipping = item.voT.shipping;
          _this61.contact = item.voT.contact;
          _this61.totalPriceUpper = "SAY US DOLLARS  " + item.voT.totalPriceUpper;
          if (_this61.shipping == 0) {
            _this61.shippingFlag = false;
          } else {
            _this61.shippingFlag = true;
          }
          var reducer = function reducer(accumulator, currentValue) {
            return accumulator + Number(currentValue.amount);
          };
          _this61.invoicePrice = _this61.invoiceVolist.reduce(reducer, 0) + Number(item.voT.shipping);
          var invoicedate = new Date();
          _this61.date = _this61.formatDate(invoicedate);
          if (item.success) {} else {
            _this61.dialogFormInvoice = false;
            _this61.msgTip("error", item.errorMsg);
          }
        });
      });
    }
  },
  //打印
  print: function print() {
    var _this62 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else {
      this.idList = [];
      this.multipleSelection.map(function (res, index) {
        _this62.idList.push(res.id);
      });
      this.idList = this.idList.reverse();
      (0, _orderLogistics.getPrint)({
        id: this.idList
      }).then(function (item) {
        if (item.success) {
          _this62.dialogFormPrint = true;
          _this62.description = window.localStorage.getItem("name");
          // this.printform = []
          _this62.printform = item.voList;
          var errorMessage = item.errorMsg;
          if (!(errorMessage == "" || errorMessage == undefined)) {
            _this62.$message({
              showClose: true,
              type: "error",
              message: errorMessage,
              center: true,
              duration: 40000
            });
          }
        } else {
          _this62.dialogFormPrint = false;
          _this62.msgTip("error", item.errorMsg);
        }
      });
    }
    //else if (this.multipleSelection.length > 1) {
    //   this.msgTip("error", "只能选择一条数据");
    //   return;
    // } else {
    // this.printLoading = true
    //  setTimeout(()=>{
    //      this.printLoading = false
    //   },5000)
    // this.printform = []

    // }
  },
  printClose: function printClose() {
    window.close();
    this.dialogFormPrint = false;
    this.getList();
    // setTimeout(()=>{
    //    this.printform = []
    // },3000)
  },
  //打印操作js方法
  printHtml: function printHtml() {
    var _this63 = this;
    this.dialogFormPrint = false;
    this.sureFlag = false;
    this.accountloading = true;
    //取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("trident") > -1) {
      alert("请使用google或者360浏览器打印");
      this.dialogFormPrint = false;
      this.sureFlag = false;
      this.accountloading = false;
      return false;
    } else if (userAgent.indexOf("msie") > -1) {
      var onlyChoseAlert = simpleAlert({
        content: "请使用Google或者360浏览器打印",
        buttons: {
          确定: function 确定() {
            onlyChoseAlert.close();
          }
        }
      });
      alert("请使用google或者360浏览器打印");
      this.dialogFormPrint = false;
      this.sureFlag = false;
      this.accountloading = false;
      return false;
    } else {
      //其它浏览器使用lodop
      // this.updateDto = []
      this.printform.map(function (item) {
        item.ordePrintLineList.map(function (res) {
          _this63.updateDto.push({
            orderNo: res.orderNo,
            serialNumber: item.serialNumber,
            printType: "1"
          });
        });
      });
      (0, _orderLogistics.updateList)({
        orderPrintSerialDTO: this.updateDto
      }).then(function (res) {
        if (res.success) {
          _this63.accountloading = false;
          _this63.$print(_this63.$refs.orderTable);
          localStorage.setItem("form", JSON.stringify(_this63.form));
        }
      });
    }
  },
  // 导出前校验：筛选字段（不含分页）至少有一个非空
  hasExportFilter: function hasExportFilter() {
    var excludeKeys = ["pageNo", "pageSize"];
    var form = this.form;
    for (var key in form) {
      if (!Object.prototype.hasOwnProperty.call(form, key)) continue;
      if (excludeKeys.indexOf(key) !== -1) continue;
      var value = form[key];
      if (Array.isArray(value)) {
        if (value.length > 0) return true;
      } else if (value !== null && value !== undefined && String(value).trim() !== "") {
        return true;
      }
    }
    return false;
  },
  //导出
  derive: function derive() {
    var _this64 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.LogisticsExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "order-logistics.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this64.loading = false;
    });
  },
  //导出-CSV
  deriveCsv: function deriveCsv() {
    var _this65 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.LogisticsExportCsv)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/csv;charset=GBK"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "order-logistics.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this65.loading = false;
    });
  },
  //导出SKU
  skuderive: function skuderive() {
    var _this66 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.LogisticsExportSku)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "order-logistics-sku.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this66.loading = false;
    });
  },
  //导出SKU-CSV
  skuderivecsv: function skuderivecsv() {
    var _this67 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.LogisticsExportSkuCsv)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/csv;charset=GBK"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "order-logistics-sku.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this67.loading = false;
    });
  },
  //UPS运单导出-CSV
  upsShipDerive: function upsShipDerive() {
    var _this68 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.upsShipExportCsv)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/csv;charset=GBK"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "WSimportShipment.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this68.loading = false;
    });
  },
  //UPS发票导出-CSV
  upsInvoiceDerive: function upsInvoiceDerive() {
    var _this69 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.upsInvoiceExportCsv)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/csv;charset=GBK"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "WSimportInv.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this69.loading = false;
    });
  },
  yamatoInvoiceDerive: function yamatoInvoiceDerive() {
    var _this70 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.yamatoInvoiceExportCsv)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/csv;charset=GBK"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "yamatoSimportShipment.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this70.loading = false;
    });
  },
  //DHL运单推送
  dhlPush: function dhlPush() {
    var _this71 = this;
    this.loading = true;
    (0, _orderLogistics.dhlPush)(this.form).then(function (res) {
      var errorMessage = res.errorMsg;
      if (res.success) {
        _this71.getList();
        _this71.$message({
          type: "success",
          message: "推送成功",
          center: true
        });
      } else {
        _this71.loading = false;
        _this71.$message({
          showClose: true,
          type: "error",
          message: errorMessage,
          center: true,
          duration: 8000
        });
      }
    });
  },
  //DHL运单推送
  dhlPushS: function dhlPushS() {
    var _this72 = this;
    this.loading = true;
    (0, _orderLogistics.dhlPushS)(this.form).then(function (res) {
      var errorMessage = res.errorMsg;
      if (res.success) {
        _this72.getList();
        _this72.$message({
          type: "success",
          message: "推送成功",
          center: true
        });
      } else {
        _this72.loading = false;
        _this72.$message({
          showClose: true,
          type: "error",
          message: errorMessage,
          center: true,
          duration: 8000
        });
      }
    });
  },
  //商品明细导出
  shopderive: function shopderive() {
    var _this73 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.shopExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "order-detail.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this73.loading = false;
    });
  },
  //运单导出
  orderderive: function orderderive() {
    var _this74 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.orderExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "DHL订单导入.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this74.loading = false;
    });
  },
  //运单下载
  downloadFile: function downloadFile(fileName, content, contentType) {
    var aLink = document.createElement("a");
    var blob = this.base64ToBlob(content.replace(/^[^,]+,/, ''), contentType);
    var evt = document.createEvent("HTMLEvents");
    console.log("点击下载", evt);
    evt.initEvent("click", true, true);
    aLink.download = 'DHL下载';
    aLink.href = URL.createObjectURL(blob);
    aLink.click();
  },
  // base64转blob
  base64ToBlob: function base64ToBlob(content, contentType) {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  },
  waybilldownload: function waybilldownload() {
    var _this75 = this;
    this.loading = true;
    (0, _orderLogistics.waydownload)(this.form).then(function (res) {
      if (res.success) {
        _this75.downloadFile('DHL运单下载', res.voT.value, 'application/pdf');
      } else {
        _this75.$message({
          type: 'error',
          message: res.errorMsg,
          center: true
        });
      }
      _this75.loading = false;
    });
  },
  //dhl申报导出
  dhlderive: function dhlderive() {
    var _this76 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.dhlExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "DHL申报导入.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this76.loading = false;
    });
  },
  //dhl申报导出
  dhlInvoiceDerive: function dhlInvoiceDerive() {
    var _this77 = this;
    if (!this.hasExportFilter()) {
      this.msgTip("error", "筛选条件不能全部为空，不支持导出");
      return;
    }
    this.loading = true;
    (0, _orderLogistics.dhlInvoiceExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "DHL发票导入.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this77.loading = false;
    });
  },
  //ems导出
  emsderive: function emsderive() {
    var _this78 = this;
    this.loading = true;
    (0, _orderInfo.emsExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "EMS订单导入.xls";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this78.loading = false;
    });
  },
  //ups导出
  upsderive: function upsderive() {
    var _this79 = this;
    this.loading = true;
    (0, _orderLogistics.upsExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "UPS订单导入.csv";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this79.loading = false;
    });
  },
  //申请退款
  orderApply: function orderApply(row) {
    var _this80 = this;
    this.$confirm("您是否要申请退款？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      (0, _orderLogistics.returnMoney)({
        orderNo: row.orderNo
      }).then(function (res) {
        if (res.success) {
          _this80.$message({
            type: 'success',
            message: '操作成功',
            center: true
          });
          _this80.getList();
        } else {
          _this80.$message({
            type: 'error',
            message: res.errorMsg,
            center: true
          });
        }
      });
    });
  },
  //sf导出
  sfderive: function sfderive() {
    var _this81 = this;
    this.loading = true;
    (0, _orderLogistics.sfExport)(this.form).then(function (res) {
      var data = new Blob([res], {
        type: "application/vnd.ms-excel"
      });
      var downloadUrl = window.URL.createObjectURL(data);
      var anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = "SF订单导入.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(data);
      _this81.loading = false;
    });
  },
  //扫码出货
  sendcode: function sendcode() {
    var _this82 = this;
    this.dialogCodeVisible = true;
    this.isShow = false;
    this.$nextTick(function () {
      _this82.$refs.codeorder.focus();
    });
  },
  changecode: function changecode(v) {
    var _this83 = this;
    if (v === '') return false;
    clearTimeout(this.endTimeout);
    this.endTimeout = null;
    this.endTimeout = (0, _timers.setTimeout)(function () {
      if (_this83.codeform.orderNo === v) {
        clearTimeout(_this83.endTimeout);
        _this83.$refs.codenumber.focus();
        (0, _ordercustomer.getOrderNo)(v).then(function (res) {
          if (res.success) {
            _this83.codeform.dealer = res.voT.dealer;
            _this83.tableDatas = res.voT.productList;
            _this83.returnflags = true;
          } else {
            _this83.codeform.dealer = "";
            _this83.$message({
              type: "error",
              message: res.errorMsg,
              center: true
            });
          }
        });
        (0, _orderLogistics.getCount)(v).then(function (res) {
          if (res.success) {
            if (res.voT == 0) {
              _this83.isShow = false;
            } else {
              _this83.isShow = true;
            }
            _this83.equipmentCount = res.voT;
            _this83.codeform.equipmentNumberList = Array.from({
              length: _this83.equipmentCount
            }).map(function (v) {
              return {
                value: ""
              };
            });
          }
        });
      }
    }, 1000);
  },
  changenumber: function changenumber(v) {
    var _this84 = this;
    if (v) {
      (0, _timers.setTimeout)(function () {
        _this84.$refs["code0"][0].focus();
      }, 1000);
    }
  },
  changequipment: function changequipment(v) {
    var _this85 = this;
    if (v && v <= this.equipmentCount) {
      (0, _timers.setTimeout)(function () {
        _this85.$refs["code".concat(v)] && _this85.$refs["code".concat(v)][0].focus();
      }, 1000);
    }
  },
  //扫码关闭
  codeClose: function codeClose() {
    this.dialogCodeVisible = false;
    this.isShow = false;
    this.codeform.orderNo = "";
    this.codeform.number = "";
    this.codeform.dealer = "";
    this.returnflags = false;
    // this.tableDatas = []
    this.$refs.codeform.resetFields();
  },
  //回车搜索
  entersave: function entersave() {
    var _this86 = this;
    document.onkeydown = function (e) {
      //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
      if (e.keyCode === 13 && e.target.baseURI.match(/orderLogistics/)) {
        //回车后执行搜索方法
        _this86.save();
      }
    };
  },
  //扫码保存
  save: function save() {
    var _this87 = this;
    this.$refs.codeform.validate(function (valid) {
      if (valid) {
        var keyMap = {
          productContainsVOList: 'productContainsList'
        };
        for (var i = 0; i < _this87.tableDatas.length; i++) {
          var obj = _this87.tableDatas[i];
          for (var key in obj) {
            var newKey = keyMap[key];
            if (newKey) {
              obj[newKey] = obj[key];
              // delete obj[key];
            }
          }
        }
        _this87.codeform.productList = _this87.tableDatas;
        var datas = (0, _objectSpread2.default)({}, _this87.codeform);
        var newEquimentList = [];
        newEquimentList = datas.equipmentNumberList.map(function (v) {
          return v.value;
        });
        datas.equipmentNumberList = newEquimentList;
        // data.id = this.addid;
        var isP = datas.orderNo.indexOf("P");
        var isLeng = datas.orderNo;
        console.error('111', _this87.equipmentCount);
        console.error('222', datas.equipmentNumberList);
        var arr = datas.equipmentNumberList.filter(function (it) {
          return it != "";
        });
        // if (datas.equipmentNumberList == [] && this.equipmentCounts !== 0) {
        if (arr.length !== _this87.equipmentCount && _this87.equipmentCount > 0) {
          _this87.$message({
            showClose: true,
            type: "error",
            message: "请输入设备号",
            center: true,
            duration: 10000
          });
        } else if (isLeng.length < 1) {
          _this87.$message({
            showClose: true,
            type: "error",
            message: "请填写正确的订单号",
            center: true,
            duration: 10000
          });
        } else {
          _this87.isDisable = true;
          _this87.accountloading = true;
          (0, _timers.setTimeout)(function () {
            console.log('1232111', datas.dealer);
            if (datas.dealer == '234') {
              (0, _orderLogistics.returnlogistics)(datas).then(function (res) {
                if (res.success) {
                  _this87.$message({
                    type: "success",
                    message: isLeng + " -- 发货成功",
                    center: true,
                    duration: 5000
                  });
                  _this87.codeform.orderNo = "";
                  _this87.codeform.number = "";
                  _this87.codeform.dealer = "";
                  _this87.isShow = false;
                  _this87.$refs.codeorder.focus();
                  _this87.tableDatas = [];
                  _this87.returnflags = false;
                  datas.equipmentNumberList = [];
                  _this87.getList();
                } else {
                  _this87.$message({
                    showClose: true,
                    type: "error",
                    message: res.errorMsg,
                    center: true,
                    duration: 10000
                  });
                }
                _this87.accountloading = false;
                _this87.isDisable = false;
              });
            } else {
              (0, _orderLogistics.deliverList)(datas).then(function (res) {
                if (res.success) {
                  _this87.$message({
                    type: "success",
                    message: isLeng + " -- 发货成功",
                    center: true,
                    duration: 5000
                  });
                  _this87.accountloading = false;
                  _this87.codeform.orderNo = "";
                  _this87.codeform.number = "";
                  _this87.codeform.dealer = "";
                  _this87.isShow = false;
                  _this87.$refs.codeorder.focus();
                  _this87.tableDatas = [];
                  _this87.returnflags = false;
                  _this87.isDisable = false;
                  datas.equipmentNumberList = [];
                  _this87.getList();
                } else {
                  _this87.$message({
                    showClose: true,
                    type: "error",
                    message: res.errorMsg,
                    center: true,
                    duration: 10000
                  });
                  _this87.accountloading = false;
                  _this87.isDisable = false;
                }
              });
            }
          }, 1500);
        }
      }
    });
  },
  changeReceive: function changeReceive(v) {
    this.$forceUpdate();
  },
  //循环拼接id
  myclearance: function myclearance(index, name) {
    return name + index;
  },
  //报关单出现
  clearance: function clearance(v) {
    var _this88 = this;
    this.loading = true;
    this.isDisable = true;
    //  this.dialogFormClearance = true
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else {
      this.clearanceFlag = [];
      this.boxFlag = [];
      this.boxFlags = [];
      this.invoiceFlag = [];
      this.invoiceFlags = [];
      this.contractFlag = [];
      if (v === 1) {
        this.airport = "上海浦东国际机场";
        this.contractFlag.push(false);
        var arr = this.multipleSelection.filter(function (item) {
          return !item.orderNo.includes('~');
        });
        this.multipleSelection = arr.reverse();
        if (this.multipleSelection.length < 1) {
          this.msgTip("error", "纯补录单不支持打印报关材料");
          this.loading = false;
          return;
        }
        this.multipleSelection.map(function (item, i) {
          _this88.productList = _this88.multipleSelection;
          (0, _orderLogistics.getclearance)(item.id).then(function (result) {
            if (result.success) {
              _this88.clearanceFlag.push(true);
              _this88.clearances[i] = result.voT;
              _this88.clearanceList[i] = result.voT.orderLineDeclarePrintList;
              // this.$forceUpdate();
              //  this.clearances.invoiceNo = result.voT.invoiceNo
              _this88.num = "1";
              if (result.voT.logisticsPrice == 0) {
                _this88.cfr = "FOB";
                _this88.dollar = "";
              } else {
                _this88.cfr = "CFR";
                _this88.dollar = "$";
              }
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }

            // this.img = Base64.encode(this.img)
            // console.log(this.img,'777')
          });
          (0, _orderLogistics.getbox)(item.id).then(function (result) {
            if (result.success) {
              _this88.boxs[i] = result.voT;
              _this88.boxlist[i] = result.voT.orderLinePackingPrintList;
              //  this.invoiceList[i] = result.voT.orderLinePackingPrintList;
              _this88.boxFlag.push(true);
              _this88.boxFlags.push(true);
              // this.$forceUpdate();
              // this.clearances.invoiceNo = result.voT.invoiceNo
              // this.bulk = result.voT.volume
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
          (0, _orderLogistics.getInvoice)(item.id).then(function (result) {
            if (result.success) {
              _this88.invoices[i] = result.voT;
              _this88.unit = result.voT.unit;
              _this88.invoiceList[i] = result.voT.orderLinePrintList;
              //  this.clearances.invoiceNo = result.voT.invoiceNo
              _this88.invoiceFlag.push(true);
              _this88.invoiceFlags.push(true);
              _this88.dialogFormClearance = true;
              _this88.loading = false;
              // this.$forceUpdate();
              if (result.voT.logisticsPrice == 0) {
                _this88.getCfr = "FOB";
              } else {
                _this88.getCfr = "CFR";
              }

              //  const reducer = (accumulator, currentValue) => accumulator + Number(currentValue.unitPrice * currentValue.count);
              //  this.totalprice = this.invoiceList.reduce(reducer, 0)
              //  this.totalprice = result.voT.subTotalPrice
              // 1 + 2 + 3 + 4
              // console.log(this.invoiceList.reduce(reducer, 0));
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
        });
        (0, _timers.setTimeout)(function () {
          _this88.multipleSelection.map(function (item, i) {
            (0, _orderLogistics.getCount)(item.orderNo).then(function (res) {
              if (res.success) {
                /*if (res.voT == 0) {
                  var myVar = this.myclearance(i, 'clear')
                  var mybox = this.myclearance(i, 'box')
                  var myboxs = this.myclearance(i, 'boxs')
                  var openinvoices = this.myclearance(i, 'openinvoices')
                  document.getElementById(myVar).style.display = 'none'
                  document.getElementById(mybox).style.display = 'none'
                  document.getElementById(myboxs).style.display = 'none'
                  document.getElementById(openinvoices).style.display = 'none'
                }*/
              }
            });
          });
          _this88.isDisable = false;
        }, 3000);
      } else if (v === 2) {
        this.airport = "深圳口岸";
        this.profoma = "CONTRACT";
        var arr = this.multipleSelection.filter(function (item) {
          return !item.orderNo.includes('~');
        });
        this.multipleSelection = arr.reverse();
        if (this.multipleSelection.length < 1) {
          this.msgTip("error", "纯补录单不支持打印报关材料");
          this.loading = false;
          return;
        }
        this.multipleSelection.map(function (res, i) {
          _this88.productList = _this88.multipleSelection;
          (0, _orderLogistics.getInvoices)({
            from: 1,
            orderNo: res.orderNo,
            type: 1
          }).then(function (item) {
            if (item.success) {
              _this88.contractFlag.push(true);
              _this88.invoice[i] = item.voT;
              _this88.$forceUpdate();
              if (_this88.shipping == 0) {
                _this88.shippingFlag = false;
              } else {
                _this88.shippingFlag = true;
              }
              _this88.invoiceVolist[i] = item.voT.orderLineInfoVOList;
              var invoicedate = new Date();
              _this88.date = _this88.formatDate(invoicedate);
              if (item.success) {} else {
                _this88.dialogFormInvoice = false;
                _this88.msgTip("error", item.errorMsg);
                _this88.loading = false;
              }
            } else {
              _this88.msgTip("error", item.errorMsg);
              _this88.loading = false;
            }
          });
        });
        this.multipleSelection.map(function (item, i) {
          _this88.productList = _this88.multipleSelection;
          _this88.dialogFormClearance = true;
          (0, _orderLogistics.getNoclearance)(item.id).then(function (result) {
            if (result.success) {
              _this88.clearances[i] = result.voT;
              _this88.clearanceList[i] = result.voT.orderLineDeclarePrintList;
              _this88.clearanceFlag.push(true);
              _this88.clearanceFlags.push(true);
              _this88.$forceUpdate();
              _this88.num = "1";
              if (result.voT.logisticsPrice == 0) {
                _this88.cfr = "FOB";
                _this88.dollar = "";
              } else {
                _this88.cfr = "CFR";
                _this88.dollar = "$";
              }
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
          (0, _orderLogistics.getNobox)(item.id).then(function (result) {
            if (result.success) {
              _this88.boxs[i] = result.voT;
              _this88.boxlist[i] = result.voT.orderLinePackingPrintList;
              _this88.boxFlag.push(true);
              _this88.boxFlags.push(true);
              _this88.$forceUpdate();
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
          (0, _orderLogistics.getNoInvoice)(item.id).then(function (result) {
            if (result.success) {
              _this88.invoices[i] = result.voT;
              _this88.unit = result.voT.unit;
              _this88.invoiceList[i] = result.voT.orderLinePrintList;
              _this88.invoiceFlag.push(true);
              _this88.invoiceFlags.push(true);
              _this88.$forceUpdate();
              if (result.voT.logisticsPrice == 0) {
                _this88.getCfr = "FOB";
              } else {
                _this88.getCfr = "CFR";
              }
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
        });
        (0, _timers.setTimeout)(function () {
          _this88.multipleSelection.map(function (item, i) {
            (0, _orderLogistics.getCount)(item.orderNo).then(function (res) {
              if (res.success) {
                if (res.voT == 0) {
                  var mybox = _this88.myclearance(i, 'box');
                  var myboxs = _this88.myclearance(i, 'boxs');
                  var openinvoices = _this88.myclearance(i, 'openinvoices');
                  document.getElementById(mybox).style.display = 'none';
                  document.getElementById(myboxs).style.display = 'none';
                  document.getElementById(openinvoices).style.display = 'none';
                }
              }
            });
          });
          _this88.isDisable = false;
        }, 3000);
      } else if (v === 3) {
        this.contractFlag.push(false);
        var arr = this.multipleSelection.filter(function (item) {
          return !item.orderNo.includes('~');
        });
        this.multipleSelection = arr.reverse();
        if (this.multipleSelection.length < 1) {
          this.msgTip("error", "纯补录单不支持打印报关材料");
          this.loading = false;
          return;
        }
        this.multipleSelection.map(function (item, i) {
          _this88.productList = _this88.multipleSelection;
          (0, _orderLogistics.getAllclearance)(item.id).then(function (result) {
            if (result.success) {
              _this88.clearances[i] = result.voT;
              _this88.clearanceList[i] = result.voT.orderLineDeclarePrintList;
              _this88.clearanceFlag.push(true);
              _this88.clearanceFlags.push(true);
              _this88.$forceUpdate();
              _this88.num = "1";
              if (result.voT.logisticsPrice == 0) {
                _this88.cfr = "FOB";
                _this88.dollar = "";
              } else {
                _this88.cfr = "CFR";
                _this88.dollar = "$";
              }
            } else {
              _this88.msgTip("error", result.errorMsg);
            }
          });
          (0, _orderLogistics.getAllbox)(item.id).then(function (result) {
            if (result.success) {
              _this88.boxs[i] = result.voT;
              _this88.boxlist[i] = result.voT.orderLinePackingPrintList;
              _this88.boxFlag.push(true);
              _this88.boxFlags.push(true);
              _this88.$forceUpdate();
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
          (0, _orderLogistics.getAllInvoice)(item.id).then(function (result) {
            if (result.success) {
              _this88.invoices[i] = result.voT;
              _this88.unit = result.voT.unit;
              _this88.invoiceList[i] = result.voT.orderLinePrintList;
              _this88.invoiceFlags.push(true);
              _this88.invoiceFlag.push(true);
              _this88.dialogFormClearance = true;
              _this88.loading = false;
              _this88.$forceUpdate();
              if (result.voT.logisticsPrice == 0) {
                _this88.getCfr = "FOB";
              } else {
                _this88.getCfr = "CFR";
              }
            } else {
              _this88.msgTip("error", result.errorMsg);
              _this88.loading = false;
            }
          });
        });
        (0, _timers.setTimeout)(function () {
          _this88.multipleSelection.map(function (item, i) {
            if (!item.orderNo.includes('~')) {
              (0, _orderLogistics.getCount)(item.orderNo).then(function (res) {
                if (res.success) {
                  if (res.voT == 0) {
                    var myVar = _this88.myclearance(i, 'clear');
                    var mybox = _this88.myclearance(i, 'box');
                    var myboxs = _this88.myclearance(i, 'boxs');
                    var openinvoices = _this88.myclearance(i, 'openinvoices');
                    document.getElementById(mybox).style.display = 'none';
                    document.getElementById(myboxs).style.display = 'none';
                    document.getElementById(myVar).style.display = 'none';
                    document.getElementById(openinvoices).style.display = 'none';
                  }
                }
              });
            }
          });
          _this88.isDisable = false;
        }, 10000);
      }
    }
  },
  //报关材料--拆分
  splitClick: function splitClick() {
    var _this89 = this;
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.loading = true;
      this.multipleSelection.map(function (item) {
        (0, _orderInfo.getContains)(item.orderNo).then(function (item) {
          if (item.success) {
            _this89.productList = item.voT.productList;
            var arr1 = item.voT.productList.filter(function (item) {
              return item.productNo.includes('SN');
            });
            item.voT.productList = arr1;
            if (arr1.length < 1) {
              _this89.msgTip("error", "纯配件不支持报关材料均等拆分");
              _this89.loading = false;
              return;
            }
            item.voT.productList.map(function (res, i) {
              (0, _orderLogistics.getSplitclearance)(res.orderLineId).then(function (result) {
                if (result.success) {
                  _this89.clearances[i] = result.voT;
                  _this89.clearanceList[i] = result.voT.orderLineDeclarePrintList;
                  _this89.clearanceFlag.push(true);
                  _this89.clearanceFlags.push(true);
                  _this89.$forceUpdate();
                  _this89.num = "1";
                  if (result.voT.logisticsPrice == 0) {
                    _this89.cfr = "FOB";
                    _this89.dollar = "";
                  } else {
                    _this89.cfr = "CFR";
                    _this89.dollar = "$";
                  }
                } else {
                  _this89.msgTip("error", result.errorMsg);
                  _this89.loading = false;
                }
              });
              (0, _orderLogistics.getSplitinvoice)(res.orderLineId).then(function (res) {
                if (res.success) {
                  _this89.invoices[i] = res.voT;
                  _this89.unit = res.voT.unit;
                  _this89.invoiceList[i] = res.voT.orderLinePrintList;
                  _this89.invoiceFlag.push(true);
                  _this89.invoiceFlags.push(true);
                  _this89.$forceUpdate();
                  if (res.voT.logisticsPrice == 0) {
                    _this89.getCfr = "FOB";
                  } else {
                    _this89.getCfr = "CFR";
                  }
                  // this.totalprice  = res.voT.subTotalPrice
                } else {
                  _this89.msgTip("error", res.errorMsg);
                  _this89.loading = false;
                }
              });
              (0, _orderLogistics.getSplitpacking)(res.orderLineId).then(function (response) {
                if (response.success) {
                  _this89.boxs[i] = response.voT;
                  _this89.boxlist[i] = response.voT.orderLinePackingPrintList;
                  _this89.boxFlag.push(true);
                  _this89.boxFlags.push(true);
                  _this89.dialogFormClearance = true;
                  _this89.loading = false;
                  _this89.$forceUpdate();
                } else {
                  _this89.msgTip("error", response.errorMsg);
                  _this89.loading = false;
                }
              });
            });
          } else {
            _this89.msgTip("error", item.errorMsg);
          }
        });
      });
    }
  },
  //报关单关闭
  clearanceClose: function clearanceClose() {
    this.dialogFormClearance = false;
    this.dialogFormClearances = false;
    this.loading = false;
    this.clearanceFlag = [];
    this.clearanceFlags = [];
    this.invoiceFlag = [];
    this.invoiceFlags = [];
    this.boxFlag = [];
    this.boxFlags = [];
    this.contractFlag = [];
    this.getList();
  },
  //报关单确定
  clearanceHtml: function clearanceHtml() {
    this.dialogFormClearance = false;

    //取得浏览器的userAgent字符串
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("trident") > -1) {
      alert("请使用google或者360浏览器打印");
      this.dialogFormClearance = false;
      return false;
    } else if (userAgent.indexOf("msie") > -1) {
      var onlyChoseAlert = simpleAlert({
        content: "请使用Google或者360浏览器打印",
        buttons: {
          确定: function 确定() {
            onlyChoseAlert.close();
          }
        }
      });
      alert("请使用google或者360浏览器打印");
      this.dialogFormClearance = false;
      return false;
    } else {
      this.$print(this.$refs.clearance);
      localStorage.setItem("form", JSON.stringify(this.form));
      this.printFlag = false;
    }
  },
  //装箱单
  box: function box() {
    // this.dialogFormBox = true
    if (this.multipleSelection.length < 1) {
      this.msgTip("error", "请选择一条数据");
      return;
    } else if (this.multipleSelection.length > 1) {
      this.msgTip("error", "只能选择一条数据");
      return;
    } else {
      this.dialogFormBox = true;
      this.multipleSelection.map(function (res) {});
    }
  },
  changeprice: function changeprice(item) {
    // const reducer = (accumulator, currentValue) => accumulator + Number(currentValue.unitPrice * currentValue.count);
    // this.totalprice = this.invoiceList.reduce(reducer, 0)
  }
}), "beforeDestroy", function beforeDestroy() {
  // window.removeEventListener('scroll',this.handleScroll)
  window.removeEventListener('mousemove', this.handleScroll);
  document.removeEventListener('click', this.handleFunctionDocumentClick);
});